import { ArrowLongRightPdfIcon as e, Box as t, Button as n, Center as r, Divider as i, EmptyState as a, Flex as o, GreyGrey10 as s, GreyGrey100 as c, GreyGrey20 as l, GreyGrey30 as u, GreyGrey50 as ee, GreyGrey60 as d, GreyGrey70 as te, GreyGrey80 as f, GreyWhite as ne, Grid as re, GridItem as p, IconCreditCard as ie, Image as ae, IndigoIndigo60 as oe, Lato12Bold as se, Lato12Regular as ce, Lato16Bold as le, Lato24Bold as ue, Modal as de, Primary12SemiBold as fe, Primary12UppercaseSemiBold as pe, Primary13Regular as m, Primary13SemiBold as me, Primary14SemiBold as he, Primary16SemiBold as ge, SequenceMenu as _e, Spinner as ve, Table as ye, Tbody as be, Td as h, Text as g, Thead as xe, Tooltip as Se, Tr as Ce, Wordmark as we } from "@sequencehq/core-components";
import { formatAddress as _, formatDecimal as Te, formatDecimalPlaces as Ee, formatSortCode as De, localDateWithFormat as Oe, percentageFromDecimal as ke, registerReactPdfFonts as Ae, toBankAccountTypeDescription as v, toCurrencyName as je, toMoney as y, toPercentage as Me } from "@sequencehq/utils";
import { Fragment as b, jsx as x, jsxs as S } from "react/jsx-runtime";
import { Document as Ne, Image as Pe, Link as C, Page as Fe, Path as w, StyleSheet as Ie, Svg as Le, Text as T, View as E } from "@react-pdf/renderer";
import { P as Re, match as D } from "ts-pattern";
import { formatDateRange as O, outputDateToApi as ze, parseISO as Be } from "@sequencehq/utils/dates";
import { forwardRef as Ve, useEffect as He, useLayoutEffect as Ue, useMemo as We, useRef as Ge, useState as Ke } from "react";
import { Provider as qe, atom as k, useAtom as Je, useAtomValue as A, useSetAtom as Ye } from "jotai";
import { dequal as Xe } from "dequal";
import j from "big.js";
import { useHydrateAtoms as Ze } from "jotai/utils";
//#region \0rolldown/runtime.js
var Qe = Object.defineProperty, $e = (e, t) => {
	let n = {};
	for (var r in e) Qe(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Qe(n, Symbol.toStringTag, { value: "Module" }), n;
}, M = ({ address: e }) => /* @__PURE__ */ x(g, {
	textStyle: "invoicePaymentContent",
	children: _(e).join(", ")
}), et = ({ ukBankDetails: e, accountName: n, merchantAddress: r, includeBeneficiaryAddress: a }) => /* @__PURE__ */ S(b, { children: [
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(g, {
		textStyle: "infoText",
		children: "Via UK bank transfer"
	}),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account name"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: n
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	a && /* @__PURE__ */ S(b, { children: [/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(M, { address: r })
	] }), /* @__PURE__ */ x(t, { h: "9px" })] }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account number"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.accountNumber
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Sort code"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.sortCode
		})
	] })
] }), tt = ({ canadianInternationalDestination: e, merchantAddress: n, includeBeneficiaryAddress: r }) => /* @__PURE__ */ S(b, { children: [
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(o, { children: /* @__PURE__ */ x(g, {
		textStyle: "infoText",
		children: "Beneficiary"
	}) }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Legal name"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.legalName
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	r && /* @__PURE__ */ S(b, { children: [/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(M, { address: n })
	] }), /* @__PURE__ */ x(t, { h: "9px" })] }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account number"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.accountNumber
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Transit number"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.transitNumber
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ x(o, { children: /* @__PURE__ */ x(g, {
		textStyle: "infoText",
		children: "Beneficiary bank"
	}) }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank name"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.bankName
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank address"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(M, { address: e.bankAddress })
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Institution number"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.institutionNumber
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Swift code"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.swiftCode
		})
	] }),
	e.intermediaryBank && /* @__PURE__ */ S(b, { children: [
		/* @__PURE__ */ x(t, { h: "9px" }),
		/* @__PURE__ */ x(o, { children: /* @__PURE__ */ x(g, {
			textStyle: "infoText",
			children: "Intermediary bank"
		}) }),
		/* @__PURE__ */ x(t, { h: "9px" }),
		/* @__PURE__ */ S(o, { children: [
			/* @__PURE__ */ x(g, {
				textStyle: "invoicePaymentTitle",
				w: "160px",
				children: "Bank name"
			}),
			/* @__PURE__ */ x(t, { w: "16px" }),
			/* @__PURE__ */ x(g, {
				textStyle: "invoicePaymentContent",
				children: e.intermediaryBank.bankName
			})
		] }),
		/* @__PURE__ */ x(t, { h: "9px" }),
		/* @__PURE__ */ S(o, { children: [
			/* @__PURE__ */ x(g, {
				textStyle: "invoicePaymentTitle",
				w: "160px",
				children: "Bank address"
			}),
			/* @__PURE__ */ x(t, { w: "16px" }),
			/* @__PURE__ */ x(M, { address: e.intermediaryBank.bankAddress })
		] }),
		/* @__PURE__ */ x(t, { h: "9px" }),
		/* @__PURE__ */ S(o, { children: [
			/* @__PURE__ */ x(g, {
				textStyle: "invoicePaymentTitle",
				w: "160px",
				children: "Routing number"
			}),
			/* @__PURE__ */ x(t, { w: "16px" }),
			/* @__PURE__ */ x(g, {
				textStyle: "invoicePaymentContent",
				children: e.intermediaryBank.routingNumber
			})
		] }),
		/* @__PURE__ */ x(t, { h: "9px" }),
		/* @__PURE__ */ S(o, { children: [
			/* @__PURE__ */ x(g, {
				textStyle: "invoicePaymentTitle",
				w: "160px",
				children: "Swift code"
			}),
			/* @__PURE__ */ x(t, { w: "16px" }),
			/* @__PURE__ */ x(g, {
				textStyle: "invoicePaymentContent",
				children: e.intermediaryBank.swiftCode
			})
		] })
	] })
] }), nt = ({ canadianBankDetails: e, accountName: n, merchantAddress: r, includeBeneficiaryAddress: a }) => /* @__PURE__ */ S(b, { children: [
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(g, {
		textStyle: "infoText",
		children: "Via Canadian bank transfer"
	}),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account name"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: n
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	a && /* @__PURE__ */ S(b, { children: [/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(M, { address: r })
	] }), /* @__PURE__ */ x(t, { h: "9px" })] }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account number"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.accountNumber
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Transit number"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.transitNumber
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Institution number"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.institutionNumber
		})
	] })
] }), rt = ({ iban: e, accountName: n, merchantAddress: r, includeBeneficiaryAddress: a }) => /* @__PURE__ */ S(b, { children: [
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(g, {
		textStyle: "infoText",
		children: "Via bank transfer"
	}),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account name"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: n
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	a && /* @__PURE__ */ S(b, { children: [/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(M, { address: r })
	] }), /* @__PURE__ */ x(t, { h: "9px" })] }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "IBAN"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e
		})
	] })
] }), it = ({ achDetails: e, merchantAddress: n, includeBeneficiaryAddress: r }) => /* @__PURE__ */ S(b, { children: [
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(g, {
		textStyle: "infoText",
		children: "Via ACH"
	}),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account name"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.accountName
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	r && /* @__PURE__ */ S(b, { children: [/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(M, { address: n })
	] }), /* @__PURE__ */ x(t, { h: "9px" })] }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account number"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.accountNumber
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank name"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.bankName
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank routing number"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.bankRoutingNumber
		})
	] })
] }), at = ({ wireDetails: e, merchantAddress: n, includeBeneficiaryAddress: r }) => /* @__PURE__ */ S(b, { children: [
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(i, { borderColor: "gray.40" }),
	/* @__PURE__ */ x(t, { h: "8px" }),
	/* @__PURE__ */ x(g, {
		textStyle: "infoText",
		children: "Via Wire"
	}),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account name"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.accountName
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	r && /* @__PURE__ */ S(b, { children: [/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Address"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(M, { address: n })
	] }), /* @__PURE__ */ x(t, { h: "9px" })] }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Account number"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.accountNumber
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank name"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.bankName
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank routing number"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			children: e.bankRoutingNumber
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Swift code"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentContent",
			textAlign: "right",
			children: e.swiftCode
		})
	] }),
	/* @__PURE__ */ x(t, { h: "9px" }),
	/* @__PURE__ */ S(o, { children: [
		/* @__PURE__ */ x(g, {
			textStyle: "invoicePaymentTitle",
			w: "160px",
			children: "Bank address"
		}),
		/* @__PURE__ */ x(t, { w: "16px" }),
		/* @__PURE__ */ x(M, { address: e.bankAddress })
	] })
] }), N = (e) => e.match(/\w+|\W+/g)?.map((e) => e.replace(/ /g, "\xA0")), P = (e) => {
	let t = Number(e.fontSize.replace("px", "")), n = Number(e.lineHeight.replace("px", ""));
	return {
		...e,
		fontSize: t,
		lineHeight: n / t
	};
}, ot = (e, t) => {
	let n = Math.ceil(e.length / t);
	return Array.from({ length: n }, (n, r) => e.slice(r * t, r * t + t));
}, F = Ie.create({
	page: {
		backgroundColor: "white",
		paddingBottom: 89,
		paddingTop: 32
	},
	wrapper: {
		paddingLeft: 24,
		paddingRight: 24
	},
	pageAccent: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: 4
	},
	pageFooter: {
		position: "absolute",
		bottom: 0,
		left: 0,
		width: "100%",
		padding: 24
	},
	pageSeparator: {
		height: 1,
		backgroundColor: u
	},
	watermark: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100vw",
		height: "100vh",
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	watermarkText: {
		fontFamily: "Lato",
		fontStyle: "normal",
		fontWeight: "bold",
		fontSize: 144,
		textTransform: "uppercase",
		opacity: .3,
		transform: "rotate(-45deg)"
	},
	sectionHeader: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: 16
	},
	sectionSummary: {
		display: "flex",
		flexDirection: "row",
		gap: 16,
		marginBottom: 24
	},
	sectionInvoicePaymentOverview: {
		marginBottom: 24,
		gap: 8
	},
	lato24BoldGreyGrey100: {
		...P(ue),
		color: c
	},
	lato24BoldGreyGrey80: {
		...P(ue),
		color: f
	},
	lato16BoldGreyGrey100: {
		...P(le),
		color: c
	},
	lato16BoldGreyGrey80: {
		...P(le),
		color: f
	},
	lato12RegularGreyGrey100: {
		...P(ce),
		color: c
	},
	lato12RegularGreyGrey80: {
		...P(ce),
		color: f
	},
	lato12RegularGreyGrey60: {
		...P(ce),
		color: d
	},
	lato12BoldGreyGrey100: {
		...P(se),
		color: c
	},
	lato12BoldGreyGrey80: {
		...P(se),
		color: f
	},
	lato12BoldLink: {
		...P(se),
		color: oe,
		textDecoration: "none"
	}
}), { lato12BoldGreyGrey80: st, lato12RegularGreyGrey80: I } = F, ct = ({ style: e, heading: t, name: n, address: r, phoneNumber: i, email: a, taxId: o }) => {
	let s = _(r);
	return /* @__PURE__ */ S(E, {
		style: e,
		children: [
			/* @__PURE__ */ x(T, {
				style: st,
				children: t
			}),
			n && /* @__PURE__ */ x(T, {
				style: I,
				children: n
			}),
			s.map((e, t) => /* @__PURE__ */ x(T, {
				style: I,
				children: e
			}, t)),
			i && /* @__PURE__ */ x(T, {
				style: I,
				children: i
			}),
			a && /* @__PURE__ */ x(T, {
				style: I,
				children: a
			}),
			o && /* @__PURE__ */ S(T, {
				style: I,
				children: ["Tax ID: ", o]
			})
		]
	});
}, { sectionInvoicePaymentOverview: lt, lato16BoldGreyGrey80: ut } = F, dt = ({ creditNote: { currency: e, grossTotal: t } }) => /* @__PURE__ */ x(E, {
	style: lt,
	children: /* @__PURE__ */ x(T, {
		style: ut,
		children: y({
			currency: e,
			value: t,
			appendCurrencyCode: !0
		})
	})
}), L = (e) => D(e).with("creditNoteNumber", () => "Credit note number").with("invoiceNumber", () => "Related invoice").with("issueDate", () => "Date of issue").with("purchaseOrderNumber", () => "Purchase order").with("billingPeriod", () => "Billing period").exhaustive(), ft = (e) => e || "Pending", pt = (e) => e ? Oe(e, "d MMMM yyyy") : "Pending issuing", mt = (e) => O({
	from: new Date(e.start),
	to: new Date(e.endInclusive),
	separator: "-"
}), ht = ({ lineItem: e, currency: t }) => e.rateDisplay === "PERCENTAGE" ? y({
	currency: t,
	value: e.quantity
}) : e.quantity, gt = ({ lineItem: e, currency: t }) => e.rateDisplay === "PERCENTAGE" ? Me(ke(e.rate)) : y({
	currency: t,
	value: e.rate,
	maximumFractionDigits: 10
}), _t = ({ lineItem: e }) => Me(ke(e.taxRate)), vt = ({ lineItem: e, currency: t }) => y({
	currency: t,
	value: e.netTotal
}), { sectionSummary: yt, lato12RegularGreyGrey80: bt } = F, xt = ({ creditNote: e, merchantDetails: t }) => {
	let { invoiceNumber: n, purchaseOrderNumber: r, issueDate: i, memo: a, customerLegalCompanyName: o, customerBillingAddress: s, customerTaxId: c, creditNoteNumber: l, billingPeriodStart: u, billingPeriodEnd: ee } = e;
	return /* @__PURE__ */ S(E, {
		style: yt,
		children: [/* @__PURE__ */ S(E, {
			style: {
				width: 312,
				gap: 16
			},
			children: [
				/* @__PURE__ */ S(E, { children: [
					/* @__PURE__ */ x(R, {
						title: L("creditNoteNumber"),
						value: l || "Pending"
					}),
					r && /* @__PURE__ */ x(R, {
						title: L("purchaseOrderNumber"),
						value: r
					}),
					n && /* @__PURE__ */ x(R, {
						title: L("invoiceNumber"),
						value: n
					}),
					u && ee && /* @__PURE__ */ x(R, {
						title: L("billingPeriod"),
						value: mt({
							start: u,
							endInclusive: ee
						})
					}),
					/* @__PURE__ */ x(R, {
						title: L("issueDate"),
						value: pt(i)
					})
				] }),
				/* @__PURE__ */ x(ct, {
					heading: "Credited to",
					name: o,
					address: s,
					taxId: c,
					customerCountry: s?.country
				}),
				a && /* @__PURE__ */ x(T, {
					style: bt,
					children: a
				})
			]
		}), t && /* @__PURE__ */ x(ct, {
			style: {
				flex: 1,
				textAlign: "right"
			},
			heading: t.legalCompanyName,
			address: t.address,
			phoneNumber: t.phoneNumber,
			email: t.email,
			taxId: t.taxId,
			customerCountry: s?.country
		})]
	});
}, { lato12RegularGreyGrey80: St, lato12BoldGreyGrey80: Ct } = F, R = ({ title: e, value: t }) => /* @__PURE__ */ S(E, {
	style: {
		display: "flex",
		flexDirection: "row",
		flexWrap: "wrap"
	},
	children: [
		N(`${e}:`)?.map((e, t) => /* @__PURE__ */ x(T, {
			style: Ct,
			children: e
		}, t)),
		/* @__PURE__ */ x(T, {
			style: Ct,
			children: " "
		}),
		N(t)?.map((e, t) => /* @__PURE__ */ x(T, {
			style: St,
			children: e
		}, t))
	]
}), { lato12BoldGreyGrey100: wt } = F, Tt = ({ title: e, currency: t, netTotal: n, totalTax: r, grossTotal: i, finalTotalLabel: a }) => /* @__PURE__ */ S(E, {
	style: {
		minWidth: 244,
		marginBottom: "16px"
	},
	children: [
		e && /* @__PURE__ */ x(T, {
			style: wt,
			children: e
		}),
		/* @__PURE__ */ x(kt, {
			title: "Subtotal",
			value: y({
				currency: t,
				value: n
			})
		}),
		/* @__PURE__ */ x(kt, {
			title: "Tax",
			value: y({
				currency: t,
				value: r
			})
		}),
		/* @__PURE__ */ x(kt, {
			title: a,
			value: y({
				currency: t,
				value: i,
				appendCurrencyCode: !0
			}),
			textStyle: wt,
			borderBottom: 0
		})
	]
}), Et = ({ creditNote: e, refTotalsPage: t }) => {
	let { currency: n, netTotal: r, grossTotal: i, totalTax: a } = e;
	return /* @__PURE__ */ S(E, {
		style: {
			display: "flex",
			alignItems: "flex-end"
		},
		wrap: !1,
		children: [/* @__PURE__ */ x(E, {
			style: { minWidth: 244 },
			children: /* @__PURE__ */ x(Tt, {
				currency: n,
				netTotal: r,
				totalTax: a,
				grossTotal: i,
				finalTotalLabel: "Credit total"
			})
		}), /* @__PURE__ */ x(T, {
			render: ({ pageNumber: e }) => (t.current = e, ""),
			style: { display: "none" }
		})]
	});
}, { lato12RegularGreyGrey100: Dt } = F, Ot = {
	display: "flex",
	flexDirection: "row",
	borderBottom: 1,
	borderBottomStyle: "solid",
	borderBottomColor: u,
	paddingTop: 7,
	paddingBottom: 7,
	justifyContent: "space-between",
	gap: 16
}, kt = ({ title: e, value: t, textStyle: n = Dt, borderBottom: r }) => /* @__PURE__ */ S(E, {
	style: {
		...Ot,
		...r === void 0 ? {} : { borderBottom: r }
	},
	children: [/* @__PURE__ */ x(T, {
		style: { ...n },
		children: e
	}), /* @__PURE__ */ x(T, {
		style: {
			...n,
			textAlign: "right"
		},
		children: t
	})]
}), { lato24BoldGreyGrey100: At, lato16BoldGreyGrey100: jt, sectionHeader: Mt } = F, Nt = ({ merchantDetails: e, isRenderedInBrowser: t }) => /* @__PURE__ */ S(E, {
	style: Mt,
	children: [/* @__PURE__ */ x(T, {
		style: At,
		children: "Credit note"
	}), e.logoUrl ? /* @__PURE__ */ x(Pt, {
		logoUrl: e.logoUrl,
		isRenderedInBrowser: t
	}) : /* @__PURE__ */ x(T, {
		style: jt,
		children: e.legalCompanyName
	})]
}), Pt = ({ logoUrl: e, isRenderedInBrowser: t }) => /* @__PURE__ */ x(E, { children: /* @__PURE__ */ x(Pe, {
	src: t ? {
		uri: e,
		method: "GET",
		headers: { "Cache-Control": "no-cache" },
		body: ""
	} : e,
	style: { height: 28 }
}) }), { pageAccent: Ft } = F, It = ({ merchantDetails: e }) => {
	let t = e.primaryColour ?? "transparent";
	return /* @__PURE__ */ x(E, {
		style: {
			...Ft,
			backgroundColor: t
		},
		fixed: !0
	});
}, { pageFooter: Lt, pageSeparator: Rt, lato12RegularGreyGrey80: zt } = F, Bt = ({ text: e, refTotalsPage: t }) => /* @__PURE__ */ x(E, {
	style: Lt,
	fixed: !0,
	children: /* @__PURE__ */ x(E, {
		style: {
			display: "flex",
			gap: 24,
			justifyContent: "flex-end"
		},
		render: ({ pageNumber: n }) => /* @__PURE__ */ S(b, { children: [
			n === t.current && /* @__PURE__ */ x(Ht, {}),
			/* @__PURE__ */ x(E, { style: Rt }),
			/* @__PURE__ */ S(E, {
				style: {
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					width: "100%"
				},
				children: [/* @__PURE__ */ x(T, {
					style: zt,
					children: e
				}), /* @__PURE__ */ x(T, {
					style: zt,
					render: ({ totalPages: e }) => `Page ${n} of ${e}`
				})]
			})
		] })
	})
}), { lato12RegularGreyGrey80: Vt } = F, Ht = () => /* @__PURE__ */ S(C, {
	href: "https://sequencehq.com?utm_campaign=pdf-credit-note",
	style: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		textDecoration: "none"
	},
	children: [/* @__PURE__ */ x(T, {
		style: {
			...Vt,
			marginRight: 4
		},
		children: "Powered by"
	}), /* @__PURE__ */ x(Ut, {})]
}), Ut = () => /* @__PURE__ */ S(Le, {
	width: "65",
	height: "15",
	viewBox: "0 0 65 15",
	fill: "none",
	style: {
		width: 65,
		height: 15
	},
	children: [
		/* @__PURE__ */ x(w, {
			d: "M5.36707 11.4172C6.63874 11.4172 7.64425 11.1422 8.36881 10.5923C9.09336 10.0424 9.46304 9.28989 9.46304 8.33478C9.46304 7.53886 9.19687 6.90212 8.66455 6.42457C8.13222 5.96149 7.27458 5.59971 6.07684 5.33922L5.16006 5.15109C4.27285 4.97744 3.68137 4.7459 3.35606 4.48541C3.03075 4.25387 2.86809 3.89209 2.86809 3.41454C2.86809 2.95145 3.04554 2.60414 3.41521 2.34366C3.77009 2.09765 4.30242 1.9674 4.9974 1.9674C5.88461 1.9674 6.52045 2.12659 6.9197 2.44496C7.31894 2.76333 7.54074 3.24088 7.59989 3.90656H9.1673C9.13772 2.89357 8.78284 2.09765 8.08786 1.51879C7.39287 0.93994 6.35779 0.650513 4.98262 0.650513C3.82924 0.650513 2.92724 0.910997 2.26183 1.41749C1.58164 1.92399 1.25632 2.60414 1.25632 3.44348C1.25632 4.29729 1.52249 4.96297 2.08439 5.44052C2.6315 5.93255 3.44478 6.27986 4.53901 6.48246L5.44101 6.67058C6.32822 6.87318 6.94927 7.09025 7.30415 7.33626C7.64425 7.58228 7.82169 7.92959 7.82169 8.3782C7.82169 8.94258 7.59989 9.37672 7.18586 9.66615C6.77183 9.95557 6.16557 10.1003 5.39665 10.1003C3.50393 10.1003 2.55757 9.33331 2.528 7.78487H0.945801C0.945801 8.97152 1.34505 9.88322 2.11396 10.491C2.88288 11.1133 3.97711 11.4172 5.36707 11.4172Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ x(w, {
			d: "M17.4455 7.50992C17.4455 6.35221 17.1202 5.41158 16.4843 4.65907C15.8337 3.92103 14.9465 3.54478 13.8227 3.54478C12.7433 3.54478 11.8708 3.90656 11.2054 4.61565C10.5252 5.33922 10.1999 6.27986 10.1999 7.45203C10.1999 8.63868 10.5252 9.57932 11.2054 10.2884C11.8708 11.012 12.758 11.3593 13.8523 11.3593C14.7247 11.3593 15.464 11.1422 16.0555 10.7081C16.647 10.2739 17.061 9.66615 17.268 8.89917H15.7746C15.4788 9.7385 14.843 10.1437 13.8818 10.1437C13.2312 10.1437 12.7285 9.97005 12.3588 9.59379C11.9743 9.21754 11.7525 8.66763 11.6934 7.92959H17.4455V7.50992ZM13.8227 4.76037C14.4142 4.76037 14.8873 4.9485 15.257 5.32475C15.6267 5.701 15.8485 6.17856 15.9224 6.78635H11.7082C11.7969 6.13514 12.0187 5.62865 12.3884 5.28134C12.758 4.93402 13.2312 4.76037 13.8227 4.76037Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ x(w, {
			d: "M24.1135 4.81825C23.5368 3.97892 22.694 3.54478 21.585 3.54478C20.5203 3.54478 19.6627 3.90656 19.0416 4.60118C18.4058 5.31028 18.0952 6.26539 18.0952 7.45203C18.0952 8.65315 18.4058 9.60826 19.0416 10.3029C19.6627 11.012 20.5203 11.3593 21.585 11.3593C22.6496 11.3593 23.4777 10.9686 24.0544 10.1726V14.022H25.533V3.71843H24.1135V4.81825ZM20.2393 9.43461C19.8253 8.98599 19.6331 8.34926 19.6331 7.50992C19.6331 6.67058 19.8253 6.0049 20.2393 5.51288C20.6386 5.03532 21.1857 4.78931 21.8659 4.78931C22.5609 4.78931 23.108 5.02085 23.5072 5.48393C23.8917 5.96149 24.0987 6.6127 24.0987 7.45203C24.0987 8.30584 23.8917 8.95705 23.5072 9.40566C23.108 9.88322 22.5609 10.1148 21.8659 10.1148C21.1857 10.1148 20.6386 9.89769 20.2393 9.43461Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ x(w, {
			d: "M31.9069 7.92959C31.9069 8.60974 31.7147 9.14518 31.3451 9.52143C30.9754 9.89769 30.517 10.0858 29.9847 10.0858C28.9052 10.0858 28.3729 9.56485 28.3729 8.52291V3.71843H26.8942V8.72551C26.8942 9.56485 27.1308 10.2016 27.604 10.6647C28.0772 11.1278 28.7278 11.3593 29.5706 11.3593C30.5761 11.3593 31.3746 10.9396 31.9661 10.0713V11.1856H33.3856V3.71843H31.9069V7.92959Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ x(w, {
			d: "M41.6369 7.50992C41.6369 6.35221 41.3116 5.41158 40.6758 4.65907C40.0251 3.92103 39.1379 3.54478 38.0141 3.54478C36.9347 3.54478 36.0623 3.90656 35.3968 4.61565C34.7166 5.33922 34.3913 6.27986 34.3913 7.45203C34.3913 8.63868 34.7166 9.57932 35.3968 10.2884C36.0623 11.012 36.9495 11.3593 38.0437 11.3593C38.9161 11.3593 39.6555 11.1422 40.2469 10.7081C40.8384 10.2739 41.2524 9.66615 41.4595 8.89917H39.966C39.6702 9.7385 39.0344 10.1437 38.0733 10.1437C37.4226 10.1437 36.9199 9.97005 36.5502 9.59379C36.1658 9.21754 35.944 8.66763 35.8848 7.92959H41.6369V7.50992ZM38.0141 4.76037C38.6056 4.76037 39.0788 4.9485 39.4484 5.32475C39.8181 5.701 40.0399 6.17856 40.1139 6.78635H35.8996C35.9883 6.13514 36.2101 5.62865 36.5798 5.28134C36.9495 4.93402 37.4226 4.76037 38.0141 4.76037Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ x(w, {
			d: "M46.4566 3.54478C45.4363 3.54478 44.6378 3.97892 44.0611 4.83273V3.71843H42.6416V11.1856H44.1202V6.97448C44.1202 6.27986 44.3125 5.74442 44.7117 5.36816C45.0962 5.00638 45.5398 4.81825 46.0425 4.81825C47.1072 4.81825 47.6543 5.33922 47.6543 6.38116V11.1856H49.133V6.17856C49.133 5.33922 48.8964 4.70248 48.4232 4.2394C47.95 3.77632 47.2846 3.54478 46.4566 3.54478Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ x(w, {
			d: "M53.7763 11.3593C54.693 11.3593 55.462 11.1133 56.083 10.5923C56.7041 10.0858 57.0737 9.39119 57.192 8.52291H55.6838C55.595 9.04388 55.3732 9.43461 55.0331 9.69509C54.6783 9.97004 54.2642 10.1003 53.7763 10.1003C53.1256 10.1003 52.6229 9.88322 52.2384 9.42013C51.854 8.95705 51.6765 8.30584 51.6765 7.45203C51.6765 6.6127 51.854 5.96149 52.2384 5.49841C52.6229 5.03532 53.1256 4.80378 53.7763 4.80378C54.2494 4.80378 54.6635 4.93402 55.0036 5.19451C55.3437 5.45499 55.5655 5.83125 55.669 6.32327H57.1772C57.0589 5.48393 56.6893 4.80378 56.083 4.29729C55.4767 3.80526 54.7078 3.54478 53.7763 3.54478C52.682 3.54478 51.7948 3.90656 51.1442 4.60118C50.464 5.32475 50.1387 6.26539 50.1387 7.45203C50.1387 8.63868 50.464 9.57932 51.1442 10.2884C51.8096 11.012 52.682 11.3593 53.7763 11.3593Z",
			fill: "#241F25"
		}),
		/* @__PURE__ */ x(w, {
			d: "M64.9475 7.50992C64.9475 6.35221 64.6222 5.41158 63.9863 4.65907C63.3357 3.92103 62.4485 3.54478 61.3247 3.54478C60.2452 3.54478 59.3728 3.90656 58.7074 4.61565C58.0272 5.33922 57.7019 6.27986 57.7019 7.45203C57.7019 8.63868 58.0272 9.57932 58.7074 10.2884C59.3728 11.012 60.26 11.3593 61.3543 11.3593C62.2267 11.3593 62.966 11.1422 63.5575 10.7081C64.149 10.2739 64.563 9.66615 64.77 8.89917H63.2765C62.9808 9.7385 62.345 10.1437 61.3838 10.1437C60.7332 10.1437 60.2304 9.97005 59.8608 9.59379C59.4763 9.21754 59.2545 8.66763 59.1954 7.92959H64.9475V7.50992ZM61.3247 4.76037C61.9162 4.76037 62.3893 4.9485 62.759 5.32475C63.1287 5.701 63.3505 6.17856 63.4244 6.78635H59.2102C59.2989 6.13514 59.5207 5.62865 59.8904 5.28134C60.26 4.93402 60.7332 4.76037 61.3247 4.76037Z",
			fill: "#241F25"
		})
	]
}), { lato12BoldGreyGrey100: Wt, lato12RegularGreyGrey60: Gt } = F, Kt = ({ primaryText: e, secondaryText: t, children: n, style: r }) => {
	let i = !!e || !!t;
	return /* @__PURE__ */ S(E, {
		style: r?.container,
		children: [i && /* @__PURE__ */ S(E, {
			style: {
				display: "flex",
				flexDirection: "row",
				flexWrap: "wrap",
				...r?.header ?? {}
			},
			children: [
				e && N(e)?.map((e, t) => /* @__PURE__ */ x(T, {
					style: {
						...Wt,
						minWidth: "1"
					},
					hyphenationCallback: (e) => ot(e, 78),
					children: e
				}, t)),
				t && /* @__PURE__ */ x(T, {
					style: Wt,
					children: "   "
				}),
				t && N(t)?.map((e, t) => /* @__PURE__ */ x(T, {
					style: Gt,
					hyphenationCallback: (e) => ot(e, 78),
					children: e
				}, t))
			]
		}), n]
	});
}, { lato12RegularGreyGrey100: qt, lato12RegularGreyGrey60: Jt } = F, z = ({ wrap: e = !1, value: t, secondaryValue: n, width: r, textAlign: i = "right", paddingLeft: a = 8, paddingRight: o = 8, paddingTop: s = 11, paddingBottom: c = 8, fontStyle: l = qt, secondaryFontStyle: u = Jt }) => /* @__PURE__ */ S(E, {
	style: {
		paddingTop: s,
		paddingBottom: c,
		paddingLeft: a,
		paddingRight: o,
		width: r === void 0 ? void 0 : r + a + o,
		...r === void 0 ? { flex: 1 } : {}
	},
	children: [e ? /* @__PURE__ */ x(E, {
		style: {
			display: "flex",
			flexDirection: "row",
			flexWrap: "wrap"
		},
		children: N(t)?.map((e, t) => /* @__PURE__ */ x(T, {
			style: {
				...l,
				minWidth: "1",
				maxWidth: "100%"
			},
			hyphenationCallback: (e) => ot(e, 32),
			children: e
		}, t))
	}) : /* @__PURE__ */ x(T, {
		style: {
			...l,
			textAlign: i,
			width: "100%"
		},
		children: t
	}), n && /* @__PURE__ */ x(b, { children: e ? /* @__PURE__ */ x(E, {
		style: {
			display: "flex",
			flexDirection: "row",
			flexWrap: "wrap"
		},
		children: N(n)?.map((e, t) => /* @__PURE__ */ x(T, {
			style: {
				...u,
				minWidth: "1",
				maxWidth: "100%"
			},
			hyphenationCallback: (e) => ot(e, 32),
			children: e
		}, t))
	}) : /* @__PURE__ */ x(T, {
		style: u,
		children: n
	}) })]
}), Yt = ({ children: e, borderBottom: t }) => /* @__PURE__ */ x(E, {
	style: {
		display: "flex",
		flexDirection: "row",
		...t === void 0 ? {} : {
			borderBottom: 1,
			borderBottomColor: t,
			borderBottomStyle: "solid"
		}
	},
	wrap: !1,
	children: e
}), B = {
	description: {
		value: "Description",
		paddingLeft: 0,
		textAlign: "left"
	},
	quantity: {
		value: "Qty",
		width: 52
	},
	rate: {
		value: "Rate",
		width: 88
	},
	taxRate: {
		value: "Tax",
		width: 46
	},
	netTotal: {
		value: "Price",
		width: 90,
		paddingRight: 0
	}
}, Xt = /* @__PURE__ */ $e({
	avg: () => Zt,
	default: () => Qt
}), Zt = 6.3101292775665465, Qt = {
	0: 0,
	13: 0,
	32: 2.316,
	33: 4.116,
	34: 4.764,
	35: 6.96,
	36: 6.96,
	37: 9.432,
	38: 8.436,
	39: 2.7600000000000002,
	40: 3.6,
	41: 3.6,
	42: 4.8,
	43: 6.96,
	44: 2.544,
	45: 4.164,
	46: 2.544,
	47: 4.476,
	48: 6.96,
	49: 6.96,
	50: 6.96,
	51: 6.96,
	52: 6.96,
	53: 6.96,
	54: 6.96,
	55: 6.96,
	56: 6.96,
	57: 6.96,
	58: 3.024,
	59: 3.024,
	60: 6.96,
	61: 6.96,
	62: 6.96,
	63: 4.776,
	64: 9.864,
	65: 8.16,
	66: 7.764,
	67: 8.22,
	68: 9.036,
	69: 6.972,
	70: 6.792,
	71: 8.808,
	72: 9.072000000000001,
	73: 3.684,
	74: 5.328,
	75: 8.172,
	76: 6.168,
	77: 11.040000000000001,
	78: 9.072000000000001,
	79: 9.576,
	80: 7.332,
	81: 9.576,
	82: 7.728,
	83: 6.36,
	84: 7.08,
	85: 8.76,
	86: 8.16,
	87: 12.228,
	88: 7.716,
	89: 7.548,
	90: 7.488,
	91: 3.6,
	92: 4.5,
	93: 3.6,
	94: 6.96,
	95: 4.728,
	96: 3.684,
	97: 6.0840000000000005,
	98: 6.708,
	99: 5.604,
	100: 6.708,
	101: 6.288,
	102: 4.0440000000000005,
	103: 6.132000000000001,
	104: 6.672,
	105: 3.072,
	106: 3.048,
	107: 6.288,
	108: 3.072,
	109: 9.852,
	110: 6.672,
	111: 6.672,
	112: 6.6240000000000006,
	113: 6.708,
	114: 4.836,
	115: 5.208,
	116: 4.476,
	117: 6.672,
	118: 6.144,
	119: 9.192,
	120: 6.048,
	121: 6.144,
	122: 5.5440000000000005,
	123: 3.6,
	124: 3.6,
	125: 3.6,
	126: 6.96,
	160: 2.316,
	161: 4.116,
	162: 6.96,
	163: 6.96,
	164: 6.96,
	165: 6.96,
	166: 3.6,
	167: 6.0360000000000005,
	168: 3.684,
	169: 9.576,
	170: 4.104,
	171: 5.556,
	172: 6.96,
	173: 4.164,
	174: 9.576,
	175: 3.684,
	176: 4.764,
	177: 6.96,
	178: 3.984,
	179: 3.984,
	180: 3.684,
	181: 6.672,
	182: 8.028,
	183: 3.2760000000000002,
	184: 3.684,
	185: 3.984,
	186: 4.572,
	187: 5.556,
	188: 8.544,
	189: 8.544,
	190: 8.556000000000001,
	191: 4.776,
	192: 8.16,
	193: 8.16,
	194: 8.16,
	195: 8.16,
	196: 8.16,
	197: 8.16,
	198: 11.148,
	199: 8.22,
	200: 6.972,
	201: 6.972,
	202: 6.972,
	203: 6.972,
	204: 3.684,
	205: 3.684,
	206: 3.684,
	207: 3.684,
	208: 9.468,
	209: 9.072000000000001,
	210: 9.576,
	211: 9.576,
	212: 9.576,
	213: 9.576,
	214: 9.576,
	215: 6.96,
	216: 9.576,
	217: 8.76,
	218: 8.76,
	219: 8.76,
	220: 8.76,
	221: 7.548,
	222: 7.332,
	223: 7.308,
	224: 6.0840000000000005,
	225: 6.0840000000000005,
	226: 6.0840000000000005,
	227: 6.0840000000000005,
	228: 6.0840000000000005,
	229: 6.0840000000000005,
	230: 9.792,
	231: 5.604,
	232: 6.288,
	233: 6.288,
	234: 6.288,
	235: 6.288,
	236: 3.072,
	237: 3.072,
	238: 3.072,
	239: 3.072,
	240: 6.636,
	241: 6.672,
	242: 6.672,
	243: 6.672,
	244: 6.672,
	245: 6.672,
	246: 6.672,
	247: 6.96,
	248: 6.672,
	249: 6.672,
	250: 6.672,
	251: 6.672,
	252: 6.672,
	253: 6.144,
	254: 6.6240000000000006,
	255: 6.144,
	260: 8.16,
	261: 6.0840000000000005,
	262: 8.22,
	263: 5.604,
	280: 7.128,
	281: 6.288,
	305: 3.072,
	321: 6.516,
	322: 3.852,
	323: 9.072000000000001,
	324: 6.672,
	338: 13.152000000000001,
	339: 10.404,
	346: 6.5760000000000005,
	347: 5.208,
	352: 6.36,
	353: 5.208,
	376: 7.548,
	377: 7.488,
	378: 5.5440000000000005,
	379: 7.488,
	380: 5.5440000000000005,
	381: 7.488,
	382: 5.5440000000000005,
	402: 6.96,
	710: 3.684,
	711: 3.684,
	713: 3.684,
	728: 3.684,
	729: 3.684,
	730: 3.684,
	731: 3.684,
	732: 3.684,
	733: 3.684,
	960: 7.416,
	8211: 6.672,
	8212: 9.852,
	8216: 2.544,
	8217: 2.544,
	8218: 2.544,
	8220: 4.368,
	8221: 4.368,
	8222: 4.368,
	8224: 6.96,
	8225: 6.96,
	8226: 6.96,
	8230: 8.724,
	8240: 13.836,
	8249: 3.7920000000000003,
	8250: 3.7920000000000003,
	8260: 3.684,
	8364: 6.96,
	8482: 8.64,
	8486: 8.964,
	8706: 6.96,
	8710: 8.352,
	8719: 8.208,
	8721: 8.208,
	8722: 6.96,
	8730: 6.876,
	8734: 8.208,
	8747: 4.8,
	8776: 6.96,
	8800: 6.96,
	8804: 6.96,
	8805: 6.96,
	9674: 6.96,
	9833: 0,
	64257: 6.84,
	64258: 7.128,
	avg: Zt
}, $t = (e) => e in Xt, en = (e) => {
	let t = e.charCodeAt(0).toString();
	return $t(t) ? Xt[t] : Zt;
}, tn = (e) => e.split("").map((e) => en(e)).reduce((e, t) => e + t, 0), nn = (e) => e.length === 0 ? 0 : Math.max(...e.map(tn)), rn = ({ minWidth: e, width: t }) => e !== void 0 && t < e ? e : t, an = ({ lineItems: e, currency: t }) => ({
	description: 0,
	quantity: nn(e.map((e) => ht({
		lineItem: e,
		currency: t
	}))),
	rate: nn(e.map((e) => gt({
		lineItem: e,
		currency: t
	}))),
	taxRate: nn(e.map((e) => _t({ lineItem: e }))),
	netTotal: nn(e.map((e) => vt({
		lineItem: e,
		currency: t
	})))
}), { lato12RegularGreyGrey100: on, lato12RegularGreyGrey60: sn } = F, cn = ({ lineItem: e, creditNote: t, columnWidths: n, servicePeriod: r }) => {
	let { currency: i } = t;
	return /* @__PURE__ */ S(Yt, {
		borderBottom: u,
		children: [
			/* @__PURE__ */ x(ln, {
				title: e.title,
				description: e.description,
				servicePeriod: r
			}),
			/* @__PURE__ */ x(z, {
				value: ht({
					lineItem: e,
					currency: i
				}),
				width: rn({
					minWidth: B.quantity.width,
					width: n.quantity
				})
			}),
			/* @__PURE__ */ x(z, {
				value: gt({
					lineItem: e,
					currency: i
				}),
				width: rn({
					minWidth: B.rate.width,
					width: n.rate
				})
			}),
			/* @__PURE__ */ x(z, {
				value: _t({ lineItem: e }),
				width: rn({
					minWidth: B.taxRate.width,
					width: n.taxRate
				})
			}),
			/* @__PURE__ */ x(z, {
				value: vt({
					lineItem: e,
					currency: i
				}),
				width: rn({
					minWidth: B.netTotal.width,
					width: n.netTotal
				}),
				paddingRight: B.netTotal.paddingRight
			})
		]
	});
}, ln = ({ title: e, description: t, servicePeriod: n }) => /* @__PURE__ */ S(E, {
	style: {
		paddingTop: 11,
		paddingBottom: 8,
		paddingLeft: B.description.paddingLeft,
		paddingRight: 8,
		flex: 1,
		display: "flex",
		flexDirection: "column"
	},
	children: [
		/* @__PURE__ */ x(T, {
			style: on,
			children: e
		}),
		t && /* @__PURE__ */ x(T, {
			style: sn,
			children: t
		}),
		n && /* @__PURE__ */ x(T, {
			style: sn,
			children: n
		})
	]
});
//#endregion
//#region src/utils/formatServicePeriod.ts
function un({ start: e, end: t, fallbackStart: n, fallbackEnd: r }) {
	if (e && t) return O({
		from: new Date(e),
		to: new Date(t)
	});
	if (n && r) return O({
		from: new Date(n),
		to: new Date(r)
	});
}
//#endregion
//#region src/components/ReactPdfCreditNote/LineItems/LineItems.tsx
var dn = ({ creditNote: e, lineItemGroups: t, lineItems: n, refTotalsPage: r, alwaysShowServicePeriods: i }) => {
	let { currency: a } = e, o = (t) => {
		if (i) return un({
			start: t.servicePeriodStart,
			end: t.servicePeriodEnd,
			fallbackStart: e.billingPeriodStart,
			fallbackEnd: e.billingPeriodEnd
		});
	}, s = n.filter((e) => !e.groupId), c = s.reduce((e, t) => e + Number(t.netTotal), 0).toString(), l = an({
		lineItems: s,
		currency: a
	});
	return /* @__PURE__ */ S(E, {
		style: { gap: 12 },
		children: [
			s.length > 0 && /* @__PURE__ */ S(Kt, { children: [
				/* @__PURE__ */ x(pn, { columnWidths: l }),
				s.map((t) => /* @__PURE__ */ x(cn, {
					lineItem: t,
					creditNote: e,
					columnWidths: l,
					servicePeriod: o(t)
				}, t.id)),
				/* @__PURE__ */ x(hn, { subtotal: y({
					currency: a,
					value: c
				}) })
			] }),
			t.map((t) => {
				let r = n.filter((e) => e.groupId === t.id), i = an({
					lineItems: r,
					currency: a
				});
				return /* @__PURE__ */ S(Kt, {
					primaryText: t.title,
					children: [
						/* @__PURE__ */ x(pn, { columnWidths: i }),
						r.map((t) => /* @__PURE__ */ x(cn, {
							lineItem: t,
							creditNote: e,
							columnWidths: i,
							servicePeriod: o(t)
						}, t.id)),
						/* @__PURE__ */ x(hn, { subtotal: y({
							currency: a,
							value: t.netTotal
						}) })
					]
				}, t.id);
			}),
			/* @__PURE__ */ x(Et, {
				creditNote: e,
				refTotalsPage: r
			})
		]
	});
}, { lato12RegularGreyGrey60: fn } = F, pn = ({ columnWidths: e }) => /* @__PURE__ */ x(Yt, {
	borderBottom: ee,
	children: Object.keys(B).map((t, n) => {
		let r = B[t];
		return /* @__PURE__ */ x(z, {
			value: r.value,
			width: n === 0 ? r.width : rn({
				minWidth: r.width,
				width: e[t]
			}),
			paddingLeft: r.paddingLeft,
			paddingRight: r.paddingRight,
			textAlign: r.textAlign,
			fontStyle: fn
		}, r.value);
	})
}), { lato12BoldGreyGrey100: mn } = F, hn = ({ subtotal: e }) => /* @__PURE__ */ S(Yt, { children: [/* @__PURE__ */ x(z, {
	value: "Subtotal",
	paddingLeft: 0,
	textAlign: "left",
	fontStyle: mn
}), /* @__PURE__ */ x(z, {
	value: e,
	fontStyle: mn,
	paddingRight: 0
})] }), { page: gn, wrapper: _n } = F, vn = ({ accent: e, header: t, footerString: n, refTotalsPage: r, watermarks: i, children: a, style: o = {} }) => /* @__PURE__ */ S(Fe, {
	size: "A4",
	dpi: 72,
	style: gn,
	wrap: !0,
	children: [
		e,
		/* @__PURE__ */ S(E, {
			style: {
				..._n,
				...o
			},
			children: [t, a]
		}),
		/* @__PURE__ */ x(Bt, {
			refTotalsPage: r,
			text: n
		}),
		i
	]
}), { watermark: yn, watermarkText: bn } = F, xn = ({ text: e }) => /* @__PURE__ */ x(E, {
	style: yn,
	fixed: !0,
	children: /* @__PURE__ */ x(T, {
		style: bn,
		children: e
	})
}), Sn = ({ entity: e, showNonProdWatermark: t }) => /* @__PURE__ */ S(b, { children: [
	e.status === "DRAFT" && /* @__PURE__ */ x(xn, { text: "Draft" }),
	e.status === "VOIDED" && /* @__PURE__ */ x(xn, { text: "Void" }),
	t && /* @__PURE__ */ x(xn, { text: "Test" })
] });
//#endregion
//#region src/components/ReactPdfCreditNote/ReactPdfCreditNote.tsx
Ae();
var Cn = ({ creditNote: e, lineItems: t, lineItemGroups: n, merchantDetails: r, showNonProdWatermark: i, isRenderedInBrowser: a, alwaysShowServicePeriods: o }) => {
	let s = /* @__PURE__ */ x(It, { merchantDetails: r }), c = Ge();
	return /* @__PURE__ */ x(Ne, { children: /* @__PURE__ */ x(vn, {
		accent: s,
		footerString: `${ft(e.creditNoteNumber)} — ${y({
			currency: e.currency,
			value: e.grossTotal,
			appendCurrencyCode: !0
		})}`,
		refTotalsPage: c,
		watermarks: /* @__PURE__ */ x(Sn, {
			entity: e,
			showNonProdWatermark: i
		}),
		children: /* @__PURE__ */ S(E, {
			style: { marginTop: -8 },
			children: [
				/* @__PURE__ */ x(Nt, {
					merchantDetails: r,
					isRenderedInBrowser: a
				}),
				/* @__PURE__ */ x(xt, {
					creditNote: e,
					merchantDetails: r
				}),
				/* @__PURE__ */ x(dt, { creditNote: e }),
				/* @__PURE__ */ x(dn, {
					creditNote: e,
					lineItems: t,
					lineItemGroups: n,
					refTotalsPage: c,
					alwaysShowServicePeriods: o
				})
			]
		})
	}) });
}, wn = {
	billingPeriodTextColor: f,
	groupSummaryLineTextLeftColor: te,
	groupSummaryLineTextRightColor: f,
	separatorBorderColor: u,
	grossTotalTextColor: f
}, V = (e, t) => t?.[e] ?? wn[e], Tn = ({ description: e, amount: t, styles: n }) => /* @__PURE__ */ S(o, {
	justify: "space-between",
	children: [/* @__PURE__ */ x(g, {
		...m,
		color: V("groupSummaryLineTextLeftColor", n),
		children: e
	}), /* @__PURE__ */ x(g, {
		...m,
		color: V("groupSummaryLineTextRightColor", n),
		children: t
	})]
}), En = ({ billingPeriod: e, groupSummary: t, totals: n, styles: r }) => {
	let i = !!e, a = !!t.length, c = i || a;
	return /* @__PURE__ */ S(o, {
		backgroundColor: s,
		borderRadius: "8px",
		direction: "column",
		gap: "16px",
		padding: "16px",
		children: [
			i && /* @__PURE__ */ x(g, {
				...he,
				color: V("billingPeriodTextColor", r),
				children: e
			}),
			a && /* @__PURE__ */ x(o, {
				flexDirection: "column",
				gap: "12px",
				children: t.map(({ description: e, total: t }, n) => /* @__PURE__ */ x(Tn, {
					description: e,
					amount: t,
					styles: r
				}, n))
			}),
			/* @__PURE__ */ S(o, {
				flexDirection: "column",
				gap: "12px",
				children: [/* @__PURE__ */ S(o, {
					flexDirection: "column",
					gap: "12px",
					paddingTop: c ? "12px" : "0px",
					paddingBottom: "12px",
					borderTop: c ? `${V("separatorBorderColor", r)} 1px solid` : "none",
					borderBottom: `${V("separatorBorderColor", r)} 1px solid`,
					children: [/* @__PURE__ */ x(Tn, {
						description: "Subtotal",
						amount: n.netTotal,
						styles: r
					}), /* @__PURE__ */ x(Tn, {
						description: n.taxLabel,
						amount: n.totalTax,
						styles: r
					})]
				}), /* @__PURE__ */ S(o, {
					justify: "space-between",
					align: "center",
					children: [/* @__PURE__ */ x(g, {
						...he,
						color: V("grossTotalTextColor", r),
						children: "Total"
					}), /* @__PURE__ */ x(g, {
						...ge,
						color: V("grossTotalTextColor", r),
						children: n.grossTotal
					})]
				})]
			})
		]
	});
}, Dn = (e) => {
	let t = {
		description: v("IBAN"),
		fields: [{
			label: "Account name",
			value: e.legalCompanyName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = _(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return {
		...t,
		fields: [...t.fields, {
			label: "IBAN",
			value: e.iban
		}]
	};
}, On = (e) => {
	let t = {
		description: v("UK_BANK_ACCOUNT"),
		fields: [{
			label: "Account name",
			value: e.legalCompanyName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = _(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return {
		...t,
		fields: [
			...t.fields,
			{
				label: "Account number",
				value: e.ukAccountDetails.accountNumber
			},
			{
				label: "Sort code",
				value: De({ sortCode: e.ukAccountDetails.sortCode })
			}
		]
	};
}, kn = (e) => {
	let t = {
		description: v("US_ACH"),
		fields: [{
			label: "Account name",
			value: e.usAchDetails.accountName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = _(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return {
		...t,
		fields: [
			...t.fields,
			{
				label: "Account number",
				value: e.usAchDetails.accountNumber
			},
			{
				label: "Bank name",
				value: e.usAchDetails.bankName
			},
			{
				label: "Bank routing number",
				value: e.usAchDetails.bankRoutingNumber
			}
		]
	};
}, An = (e) => {
	let t = {
		description: v("US_WIRE"),
		fields: [{
			label: "Account name",
			value: e.usWireDetails.accountName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = _(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return {
		...t,
		fields: [
			...t.fields,
			{
				label: "Account number",
				value: e.usWireDetails.accountNumber
			},
			{
				label: "Bank name",
				value: e.usWireDetails.bankName
			},
			{
				label: "Bank routing number",
				value: e.usWireDetails.bankRoutingNumber
			},
			{
				label: "SWIFT code",
				value: e.usWireDetails.swiftCode
			},
			{
				label: "Bank address",
				value: _(e.usWireDetails.bankAddress).join(", ")
			}
		]
	};
}, jn = (e) => {
	let t = {
		description: v("CA_BANK_ACCOUNT"),
		fields: [{
			label: "Account name",
			value: e.legalCompanyName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = _(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return {
		...t,
		fields: [
			...t.fields,
			{
				label: "Account number",
				value: e.caBankAccountDetails.accountNumber
			},
			{
				label: "Transit number",
				value: e.caBankAccountDetails.transitNumber
			},
			{
				label: "Institution number",
				value: e.caBankAccountDetails.institutionNumber
			}
		]
	};
}, Mn = (e) => {
	let t = {
		description: v("CA_INTERNATIONAL"),
		fields: [{
			label: "Legal name",
			value: e.canadianInternationalDestination.legalName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = _(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	if (t.fields = [
		...t.fields,
		{
			label: "Account number",
			value: e.canadianInternationalDestination.accountNumber
		},
		{
			label: "Transit number",
			value: e.canadianInternationalDestination.transitNumber
		},
		{
			label: "Bank name",
			value: e.canadianInternationalDestination.bankName
		},
		{
			label: "Bank address",
			value: _(e.canadianInternationalDestination.bankAddress).join(", ")
		},
		{
			label: "Institution number",
			value: e.canadianInternationalDestination.institutionNumber ?? ""
		},
		{
			label: "SWIFT code",
			value: e.canadianInternationalDestination.swiftCode
		}
	], e.canadianInternationalDestination.intermediaryBank) {
		let n = [
			{
				label: "Intermediary bank name",
				value: e.canadianInternationalDestination.intermediaryBank.bankName
			},
			{
				label: "Intermediary bank address",
				value: _(e.canadianInternationalDestination.intermediaryBank.bankAddress).join(", ")
			},
			{
				label: "Intermediary bank routing number",
				value: e.canadianInternationalDestination.intermediaryBank.routingNumber
			},
			{
				label: "Intermediary SWIFT code",
				value: e.canadianInternationalDestination.intermediaryBank.swiftCode
			}
		];
		t.fields = [...t.fields, ...n];
	}
	return t;
}, Nn = (e) => {
	let t = {
		description: v("AUSTRALIAN"),
		fields: [{
			label: "Legal name",
			value: e.australianDestination.legalName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = _(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return t.fields = [
		...t.fields,
		{
			label: "Account number",
			value: e.australianDestination.accountNumber
		},
		{
			label: "BSB",
			value: e.australianDestination.bsb
		},
		{
			label: "SWIFT code",
			value: e.australianDestination.swiftCode
		}
	], t;
}, Pn = (e) => {
	let t = {
		description: v("SWEDISH_BANKGIRO"),
		fields: [{
			label: "Account name",
			value: e.swedishBankgiro.accountName
		}]
	};
	if (e.includeBeneficiaryAddressInPaymentDetails) {
		let n = _(e.address);
		t.fields.push({
			label: "Beneficiary address",
			value: n.join(", ")
		});
	}
	return t.fields = [...t.fields, {
		label: "Bankgiro number",
		value: e.swedishBankgiro.bankgiroNumber
	}], t;
}, Fn = (e) => "usAchDetails" in e || "usWireDetails" in e || "caBankAccountDetails" in e, In = (e) => "usAchDestination" in e || "usWireDestination" in e || "caBankAccountDestination" in e, Ln = (e) => {
	let t = [];
	if (e.iban) {
		let n = e.iban;
		t.push(Dn({
			...e,
			iban: n
		}));
	}
	if (e.ukAccountDetails) {
		let n = e.ukAccountDetails;
		t.push(On({
			...e,
			ukAccountDetails: n
		}));
	}
	if (e.australianDestination) {
		let n = e.australianDestination;
		t.push(Nn({
			...e,
			australianDestination: n
		}));
	}
	if (e.swedishBankgiro) {
		let n = e.swedishBankgiro;
		t.push(Pn({
			...e,
			swedishBankgiro: n
		}));
	}
	if (e.canadianInternationalDestination) {
		let n = e.canadianInternationalDestination;
		t.push(Mn({
			...e,
			canadianInternationalDestination: n
		}));
	}
	if (Fn(e) && e.usAchDetails) {
		let n = e.usAchDetails;
		t.push(kn({
			...e,
			usAchDetails: n
		}));
	}
	if (In(e) && e.usAchDestination) {
		let n = e.usAchDestination;
		t.push(kn({
			...e,
			usAchDetails: n
		}));
	}
	if (Fn(e) && e.usWireDetails) {
		let n = e.usWireDetails;
		t.push(An({
			...e,
			usWireDetails: n
		}));
	}
	if (In(e) && e.usWireDestination) {
		let n = e.usWireDestination;
		t.push(An({
			...e,
			usWireDetails: n
		}));
	}
	if (Fn(e) && e.caBankAccountDetails) {
		let n = e.caBankAccountDetails;
		t.push(jn({
			...e,
			caBankAccountDetails: n
		}));
	}
	if (In(e) && e.caBankAccountDestination) {
		let n = e.caBankAccountDestination;
		t.push(jn({
			...e,
			caBankAccountDetails: n
		}));
	}
	return t;
}, Rn = {
	...pe,
	color: d,
	pr: "24px",
	py: "10px",
	textTransform: "uppercase",
	width: "fit-content"
}, zn = {
	...pe,
	color: d,
	width: "fit-content",
	whiteSpace: "nowrap",
	textAlign: "right",
	px: "12px",
	py: "10px",
	textTransform: "uppercase"
}, Bn = {
	pr: "48px",
	py: "10px",
	...m,
	color: d,
	width: "fit-content"
}, Vn = {
	width: "fit-content",
	whiteSpace: "nowrap",
	textAlign: "right",
	px: "12px",
	py: "10px",
	...m,
	color: d
}, Hn = (e) => e.usageBreakdown.length ? /* @__PURE__ */ S(o, {
	padding: "16px 24px 24px",
	background: ne,
	boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 0px 4px 0px rgba(0, 0, 0, 0.02)",
	borderRadius: "8px",
	border: `${u} 1px solid`,
	flexDirection: "column",
	children: [/* @__PURE__ */ x(o, {
		...he,
		minHeight: "36px",
		width: "100%",
		alignItems: "center",
		justifyContent: "space-between",
		children: "Usage overview"
	}), /* @__PURE__ */ S(ye, {
		variant: "lineItemGroup",
		width: "100%",
		children: [/* @__PURE__ */ x(xe, { children: /* @__PURE__ */ S(Ce, { children: [
			/* @__PURE__ */ x(h, {
				...Rn,
				children: "Sub account"
			}),
			/* @__PURE__ */ x(h, {
				...Rn,
				children: "Metric"
			}),
			/* @__PURE__ */ x(h, {
				...zn,
				children: "qty"
			})
		] }) }), /* @__PURE__ */ x(be, { children: e.usageBreakdown.map((e) => e.usageData.map((t, n) => /* @__PURE__ */ S(Ce, { children: [
			/* @__PURE__ */ x(h, {
				...Bn,
				children: !n && e.subAccountLabel
			}),
			/* @__PURE__ */ x(h, {
				...Bn,
				children: t.label
			}),
			/* @__PURE__ */ x(h, {
				...Vn,
				children: t.quantity
			})
		] }, `${e.subAccountLabel}${t.label}`))) })]
	})]
}) : null, Un = ({ isOpen: e, onClose: r, detailItems: i, merchantLegalCompanyName: s, secondaryButton: c }) => /* @__PURE__ */ S(de, {
	isOpen: e,
	onClose: r,
	width: {
		base: "calc(100svw - 32px)",
		sm: "480px"
	},
	"data-testid": "modal.payment-details",
	children: [
		/* @__PURE__ */ x(de.Header, {
			withBorder: !0,
			children: "Payment details"
		}),
		/* @__PURE__ */ x(de.Content, {
			maxHeight: "80svh",
			children: /* @__PURE__ */ S(o, {
				direction: "column",
				children: [
					s && /* @__PURE__ */ x(t, { children: /* @__PURE__ */ S(g, {
						...m,
						color: te,
						"data-testid": "modal.payment-details.merchantInstruction",
						children: ["Use the details below to pay ", s]
					}) }),
					i.map((e) => /* @__PURE__ */ S(o, {
						direction: "column",
						justifyContent: "center",
						paddingY: "8px",
						_first: { paddingTop: "0px" },
						"data-testid": `modal.payment-details.section.${e.description}`,
						children: [/* @__PURE__ */ x(o, {
							minHeight: "32px",
							alignItems: "center",
							children: /* @__PURE__ */ x(g, {
								...me,
								color: f,
								children: e.description
							})
						}), /* @__PURE__ */ x(o, {
							direction: "column",
							css: { "&:has([data-payment-details-value]:hover) > div:not(:hover)": { opacity: .6 } },
							children: e.fields.map((e) => /* @__PURE__ */ S(re, {
								gap: "16px",
								gridTemplateColumns: "140px 1fr",
								transition: "opacity 150ms ease",
								sx: {
									".pdd-row:hover .pdd-row-copy": { display: "block" },
									".pdd-row-copy svg": {
										height: "12px",
										width: "12px"
									}
								},
								children: [/* @__PURE__ */ x(g, {
									py: "4px",
									...m,
									color: d,
									children: e.label
								}), /* @__PURE__ */ x(o, {
									gap: "4px",
									className: "pdd-row",
									"data-testid": `modal.payment-details.field.${e.label}`,
									children: /* @__PURE__ */ x(Wn, { value: e.lines })
								})]
							}, e.label))
						})]
					}, e.description)),
					i.length === 0 && /* @__PURE__ */ x(a, {
						title: "No payment details",
						body: "Add details for different currencies such as ACH, Wire or\n                  regular bank transfers.",
						icon: ie,
						iconSize: "md"
					})
				]
			})
		}),
		/* @__PURE__ */ S(de.Footer, {
			withBorder: !0,
			justifyContent: c ? "space-between" : "flex-end",
			children: [c && /* @__PURE__ */ x(n, {
				variant: "secondary",
				type: "button",
				onClick: () => {
					c.onClick();
				},
				children: c.text
			}), /* @__PURE__ */ x(n, {
				variant: "primary",
				type: "button",
				"data-testid": "modal.payment-details.done",
				onClick: () => {
					r();
				},
				children: "Done"
			})]
		})
	]
}), Wn = ({ value: e }) => {
	let [t, r] = Ke(!1), i = (e) => {
		navigator.clipboard.writeText(e), r(!0), setTimeout(() => {
			r(!1);
		}, 1500);
	};
	return /* @__PURE__ */ x(Se, {
		hasArrow: !0,
		placement: "top",
		closeOnClick: !1,
		label: t ? "Copied" : "Click to copy",
		children: /* @__PURE__ */ x(n, {
			"data-payment-details-value": !0,
			variant: "unstyled",
			as: "span",
			...m,
			color: te,
			className: "group",
			onClick: () => i(e.join(", ")),
			children: /* @__PURE__ */ x(g, {
				as: "span",
				color: te,
				py: "4px",
				...m,
				fontWeight: "semibold",
				wordBreak: "break-word",
				whiteSpace: "pre-wrap",
				_groupHover: { textDecoration: "underline" },
				children: e.map((t, n) => /* @__PURE__ */ S(b, { children: [t, n < e.length - 1 && /* @__PURE__ */ x("br", {})] }))
			})
		})
	});
}, Gn = (e) => {
	let t = {
		borderBottom: e.hideBorder ? void 0 : `${u} 1px solid`,
		display: "flex",
		alignItems: "flex-start"
	};
	return /* @__PURE__ */ S(re, {
		className: "group",
		gridTemplateColumns: `266fr 60fr 76fr 44fr 144fr ${e.action ? "32px" : "0px"}`,
		background: ne,
		_hover: e.onClick ? { background: s } : {},
		position: "relative",
		opacity: e.unsynced ? .5 : 1,
		onClick: e.onClick,
		cursor: e.onClick ? "pointer" : "default",
		style: e.style,
		children: [
			e.dragHandle,
			/* @__PURE__ */ x(p, {
				...t,
				children: e.name
			}),
			/* @__PURE__ */ x(p, {
				...t,
				children: e.qty
			}),
			/* @__PURE__ */ x(p, {
				...t,
				justifyContent: "flex-end",
				children: e.rate
			}),
			/* @__PURE__ */ x(p, {
				...t,
				justifyContent: "flex-end",
				children: e.tax
			}),
			/* @__PURE__ */ x(p, {
				...t,
				justifyContent: "flex-end",
				gridColumn: e.action ? void 0 : "span 2",
				children: e.amount
			}),
			e.action ? e.unsynced ? /* @__PURE__ */ x(r, { children: /* @__PURE__ */ x(ve, {
				width: "16px",
				height: "16px",
				color: u
			}) }) : /* @__PURE__ */ x(p, {
				...t,
				alignItems: "center",
				children: e.action
			}) : null
		]
	});
}, H = Object.assign(({ value: e, otherRows: t, strong: n = !1, indentation: r = 0, "data-testid": i }) => /* @__PURE__ */ S(o, {
	flexDir: "column",
	paddingY: "8px",
	paddingLeft: `${r * 4 + 4}px`,
	gap: "8px",
	children: [/* @__PURE__ */ x(g, {
		...m,
		fontWeight: n ? "semibold" : "normal",
		color: f,
		"data-testid": i,
		children: e
	}), t?.map((e, t) => /* @__PURE__ */ x(g, {
		...m,
		color: d,
		whiteSpace: "pre-line",
		children: e
	}, t))]
}), {
	Header: ({ value: e }) => /* @__PURE__ */ x(g, {
		...fe,
		color: d,
		paddingY: "8px",
		children: e
	}),
	Skeleton: () => /* @__PURE__ */ x(t, {
		width: "70%",
		height: "8px",
		borderRadius: "8px",
		background: l,
		alignSelf: "center"
	}),
	KebabMenu: ({ items: e }) => {
		let [t, n] = Ke(!1);
		return /* @__PURE__ */ x(r, {
			boxSize: "32px",
			opacity: t ? "1" : "0",
			_groupHover: { opacity: 1 },
			children: /* @__PURE__ */ x(_e, {
				variant: "ghost",
				buttonSize: "small",
				items: e,
				onOpenChange: n
			})
		});
	}
}), Kn = Object.assign(({ children: e }) => /* @__PURE__ */ x(o, {
	flexDir: "column",
	width: "100%",
	children: e
}), {
	Row: Gn,
	Cell: H,
	Header: ({ showActionColumn: e = !0 }) => /* @__PURE__ */ x(Gn, {
		name: /* @__PURE__ */ x(H.Header, { value: "Name" }),
		qty: /* @__PURE__ */ x(H.Header, { value: "Qty" }),
		rate: /* @__PURE__ */ x(H.Header, { value: "Rate" }),
		tax: /* @__PURE__ */ x(H.Header, { value: "Tax" }),
		amount: /* @__PURE__ */ x(H.Header, { value: "Amount" }),
		action: e || void 0
	})
}), qn = {
	fontFamily: "Lato",
	fontSize: "32px",
	lineHeight: 1.25,
	fontWeight: 600
}, Jn = {
	fontFamily: "Lato",
	fontSize: "24px",
	lineHeight: 1.25,
	fontWeight: 600
}, Yn = {
	fontFamily: "Lato",
	fontSize: "12px",
	lineHeight: 1.41666,
	fontWeight: 600
}, Xn = {
	fontFamily: "Lato",
	fontSize: "18px",
	lineHeight: 1,
	fontWeight: 600
}, Zn = {
	fontFamily: "Lato",
	fontSize: "12px",
	lineHeight: 1.41666,
	fontWeight: 400
}, U = {
	fontFamily: "Lato",
	fontSize: "11px",
	lineHeight: 1.36363,
	fontWeight: 600
}, W = {
	fontFamily: "Lato",
	fontSize: "11px",
	lineHeight: 1.36363,
	fontWeight: 400
}, Qn = { DEFAULT: {
	page: { padding: "32px" },
	gridSystem: {
		columns: 16,
		columnGap: "16px"
	},
	mainPage: { gap: "32px" },
	header: {
		container: { gap: "16px" },
		total: {
			container: { gap: "4px" },
			text: {
				...qn,
				color: "#333333"
			},
			alternativeText: {
				...Jn,
				color: "#333333"
			}
		},
		invoiceTitle: {
			...Xn,
			color: "#333333"
		},
		dueDatePayOnline: {
			container: { gap: "8px" },
			dueDateText: {
				...Yn,
				color: "#333333"
			},
			urlPayOnlineText: {
				...Yn,
				color: oe,
				textDecoration: "none"
			}
		},
		merchantName: {
			...Jn,
			color: "#1F1F1f",
			textAlign: "right"
		},
		logo: { height: "32px" }
	},
	contactDetails: {
		title: {
			...U,
			color: "#333333",
			marginBottom: "4px"
		},
		body: {
			...W,
			color: "#333333"
		}
	},
	summary: {
		containerTerms: { gap: "4px" },
		header: {
			...U,
			color: "#333333",
			marginBottom: "4px"
		},
		label: {
			container: { width: "90px" },
			text: {
				...W,
				color: "#666666"
			}
		},
		value: {
			...W,
			color: "#333333"
		},
		valueLink: {
			...W,
			color: oe,
			textDecoration: "none"
		}
	},
	lineItems: { container: { gap: "24px" } },
	lineItemTable: {
		header: {
			row: {
				borderBottomWidth: "1px",
				borderBottomColor: "#E5E5E5",
				paddingTop: "8px",
				paddingBottom: "8px"
			},
			cellText: {
				...U,
				color: "#333333"
			}
		},
		body: {
			row: {
				borderBottomWidth: "1px",
				borderBottomColor: "#E5E5E5",
				paddingTop: "8px",
				paddingBottom: "8px"
			},
			rowIndentation: { paddingLeft: "8px" },
			cellContainer: { gap: "4px" },
			cellTextBase: {
				...W,
				color: "#333333"
			},
			cellTextSecondary: { color: "#808080" },
			cellTextCaption: {
				...W,
				color: "#808080"
			},
			cellTextNameFirstLevel: {
				...U,
				color: "#333333"
			},
			cellTextNameSecondLevel: {
				...W,
				color: "#333333"
			}
		}
	},
	totals: {
		container: { gap: "8px" },
		labelLink: {
			...W,
			color: oe,
			textDecoration: "none"
		},
		default: {
			text: {
				...W,
				color: "#666666"
			},
			row: {
				paddingTop: "0px",
				paddingBottom: "0px"
			}
		},
		total: {
			text: {
				...W,
				color: "#666666"
			},
			row: {
				borderTopColor: "#E5E5E5",
				borderTopWidth: "1px",
				paddingTop: "0px",
				paddingBottom: "0px"
			}
		},
		grandTotal: {
			text: {
				...U,
				color: "#333333"
			},
			row: {
				borderTopColor: "#666666",
				borderTopWidth: "1px",
				paddingTop: "8px",
				paddingBottom: "0px"
			}
		}
	},
	totalsCaptions: {
		container: {
			gap: "4px",
			marginTop: "16px"
		},
		text: {
			...W,
			color: "#666666",
			textAlign: "right"
		}
	},
	footer: {
		summary: {
			...W,
			color: "#333333"
		},
		total: {
			...W,
			color: "#333333"
		},
		container: {
			paddingTop: "16px",
			borderTopColor: "#E5E5E5",
			borderTopWidth: "1px"
		}
	},
	poweredBy: {
		text: {
			...Zn,
			color: f,
			textDecoration: "none"
		},
		logo: {
			width: "64px",
			height: "16px"
		}
	},
	detailsBlock: {
		container: { gap: "16px" },
		header: {
			container: { gap: "8px" },
			title: {
				...U,
				color: f
			},
			subtitle: {
				...W,
				color: "#666666"
			}
		},
		group: {
			container: {
				default: { gap: "4px" },
				lg: { gap: "8px" }
			},
			title: {
				...U,
				color: f
			}
		},
		item: {
			title: {
				...W,
				color: "#666666"
			},
			values: {
				container: { gap: "1px" },
				text: {
					...W,
					color: f
				}
			}
		}
	},
	watermark: { text: {
		fontFamily: "Lato",
		fontWeight: 600,
		fontSize: "144px",
		lineHeight: 1.2,
		color: "rgba(0, 0, 0, 0.3)",
		transform: "rotate(-45deg)",
		textAlign: "center"
	} },
	currencyConversion: { exchangeRate: {
		container: { gap: "8px" },
		icon: {
			boxSize: "16px",
			fill: f
		}
	} }
} }, $n = k("DEFAULT"), G = k((e) => Qn[e($n)]), er = .875, K = k((e) => tr(e(G))), tr = (e) => {
	if (typeof e == "string") return e.endsWith("px") ? `${parseInt(e, 10) * er}px` : e;
	if (typeof e == "object") {
		let t = {};
		for (let n in e) Object.hasOwn(e, n) && (t[n] = tr(e[n]));
		return t;
	}
	return e;
}, nr = "d LLLL yyyy", q = {
	REVERSE_CHARGED: "Reverse charge applies",
	AUTO_CHARGED: "You may be charged automatically for this invoice",
	TAX_ID_PREFIX: "Tax ID:"
}, rr = ({ quantity: e, rateDisplay: t, currency: n }) => D(t).with("ABSOLUTE", () => Te()(e)).with("PERCENTAGE", () => y({
	currency: n,
	value: e
})).exhaustive(), ir = ({ rate: e, rateDisplay: t, currency: n }) => e === "VARIES" ? "Varies" : D(t).with("ABSOLUTE", () => y({
	currency: n,
	value: e,
	maximumFractionDigits: 10
})).with("PERCENTAGE", () => Me(ke(e))).exhaustive(), ar = ({ taxRate: e }) => Me(Ee(ke(e), 2)), or = ({ netTotal: e, currency: t }) => y({
	currency: t,
	value: e
}), sr = ({ lineItemGroups: e, currency: t }) => ({ taxRows: cr({
	allLineItems: e.flatMap((e) => e.lineItems),
	currency: t
}) }), cr = ({ allLineItems: e, currency: t }) => {
	let n = Array.from([...new Set(e.map((e) => e.taxRate))]).sort((e, t) => new j(e).minus(new j(t)).toNumber()), r = n.length === 1 && n[0] === "0";
	return e.length === 0 || r ? [["Tax", "0"]] : n.map((n) => {
		let r = e.filter((e) => e.taxRate === n), i = r.reduce((e, t) => e.plus(new j(t.netTotal)), new j(0)).toString(), a = r.reduce((e, t) => e.plus(new j(t.totalTax)), new j(0)).toString();
		return [`Tax (${ar({ taxRate: n })} on ${y({
			value: i,
			currency: t
		})})`, a];
	});
}, J = (e) => e.includeBeneficiaryAddressInPaymentDetails ? [{
	label: "Address",
	lines: _(e.address)
}] : [], lr = (e) => [{
	description: "Bank transfer",
	fields: [
		{
			label: "Account name",
			lines: [e.legalCompanyName]
		},
		...J(e),
		{
			label: "IBAN",
			lines: [e.iban]
		}
	]
}], ur = (e) => "iban" in e, dr = (e) => [{
	description: "UK bank transfer",
	fields: [
		{
			label: "Account name",
			lines: [e.legalCompanyName]
		},
		...J(e),
		{
			label: "Account number",
			lines: [e.ukAccountDetails.accountNumber]
		},
		{
			label: "Sort code",
			lines: [De({ sortCode: e.ukAccountDetails.sortCode })]
		}
	]
}], fr = (e) => "ukAccountDetails" in e, pr = (e) => [{
	description: "Australian bank transfer",
	fields: [
		{
			label: "Legal name",
			lines: [e.australianDestination.legalName]
		},
		...J(e),
		{
			label: "Account number",
			lines: [e.australianDestination.accountNumber]
		},
		{
			label: "BSB",
			lines: [e.australianDestination.bsb]
		},
		{
			label: "Swift code",
			lines: [e.australianDestination.swiftCode]
		}
	]
}], mr = (e) => "australianDestination" in e, hr = (e) => [{
	description: "Swedish bankgiro",
	fields: [
		{
			label: "Account name",
			lines: [e.swedishBankgiroDestination.accountName]
		},
		...J(e),
		{
			label: "Bankgiro number",
			lines: [e.swedishBankgiroDestination.bankgiroNumber]
		}
	]
}], gr = (e) => "swedishBankgiroDestination" in e, _r = (e) => [{
	description: "ACH",
	fields: [
		{
			label: "Account name",
			lines: [e.usAchDetails.accountName]
		},
		...J(e),
		{
			label: "Account number",
			lines: [e.usAchDetails.accountNumber]
		},
		{
			label: "Bank name",
			lines: [e.usAchDetails.bankName]
		},
		{
			label: "Bank routing number",
			lines: [e.usAchDetails.bankRoutingNumber]
		}
	]
}], vr = (e) => "usAchDetails" in e, yr = (e) => "usAchDestination" in e, br = (e) => {
	let t = e.canadianInternationalDestination.intermediaryBank;
	return [
		{
			description: "Canadian international bank transfer",
			fields: []
		},
		{
			description: "Beneficiary",
			fields: [
				{
					label: "Legal name",
					lines: [e.canadianInternationalDestination.legalName]
				},
				...J(e),
				{
					label: "Account number",
					lines: [e.canadianInternationalDestination.accountNumber]
				},
				{
					label: "Transit number",
					lines: [e.canadianInternationalDestination.transitNumber]
				}
			]
		},
		{
			description: "Beneficiary bank",
			fields: [
				{
					label: "Bank name",
					lines: [e.canadianInternationalDestination.bankName]
				},
				{
					label: "Bank address",
					lines: _(e.canadianInternationalDestination.bankAddress)
				},
				{
					label: "Institution number",
					lines: [e.canadianInternationalDestination.institutionNumber]
				},
				{
					label: "Swift code",
					lines: [e.canadianInternationalDestination.swiftCode]
				}
			]
		},
		...t ? [{
			description: "Intermediary bank",
			fields: [
				{
					label: "Bank name",
					lines: [t.bankName]
				},
				{
					label: "Bank address",
					lines: _(t.bankAddress)
				},
				{
					label: "Routing number",
					lines: [t.routingNumber]
				},
				{
					label: "Swift code",
					lines: [t.swiftCode]
				}
			]
		}] : []
	];
}, xr = (e) => "canadianInternationalDestination" in e, Sr = (e) => [{
	description: "Wire",
	fields: [
		{
			label: "Account name",
			lines: [e.usWireDetails.accountName]
		},
		...J(e),
		{
			label: "Account number",
			lines: [e.usWireDetails.accountNumber]
		},
		{
			label: "Bank name",
			lines: [e.usWireDetails.bankName]
		},
		{
			label: "Bank routing number",
			lines: [e.usWireDetails.bankRoutingNumber]
		},
		{
			label: "Swift code",
			lines: [e.usWireDetails.swiftCode]
		},
		{
			label: "Bank address",
			lines: _(e.usWireDetails.bankAddress)
		}
	]
}], Cr = (e) => "usWireDetails" in e, wr = (e) => "usWireDestination" in e, Tr = (e) => [{
	description: "Canadian bank transfer",
	fields: [
		{
			label: "Account name",
			lines: [e.legalCompanyName]
		},
		...J(e),
		{
			label: "Account number",
			lines: [e.caBankAccountDetails.accountNumber]
		},
		{
			label: "Transit number",
			lines: [e.caBankAccountDetails.transitNumber]
		},
		{
			label: "Institution number",
			lines: [e.caBankAccountDetails.institutionNumber]
		}
	]
}], Er = (e) => "caBankAccountDetails" in e, Dr = (e) => "caBankAccountDestination" in e, Or = (e) => {
	let t = [];
	return ur(e) && t.push(...lr(e)), fr(e) && t.push(...dr(e)), mr(e) && t.push(...pr(e)), gr(e) && t.push(...hr(e)), xr(e) && t.push(...br(e)), vr(e) && t.push(..._r(e)), yr(e) && t.push(..._r({
		...e,
		usAchDetails: e.usAchDestination
	})), Cr(e) && t.push(...Sr(e)), wr(e) && t.push(...Sr({
		...e,
		usWireDetails: e.usWireDestination
	})), Er(e) && t.push(...Tr(e)), Dr(e) && t.push(...Tr({
		...e,
		caBankAccountDetails: e.caBankAccountDestination
	})), t;
}, kr = (e) => {
	let t = e.reduce((e, t) => t.items.reduce((e, n) => n.value === "0" || !n.value ? e : {
		...e,
		[n.title]: {
			subAccountLabel: n.title,
			usageData: [...e[n.title]?.usageData ?? [], {
				label: t.title,
				quantity: n.value
			}]
		}
	}, e), {});
	return Object.values(t);
}, Ar = ({ invoiceBillingPeriod: e, groupLineItems: t }) => {
	if (t.length === 0) return {
		showForLineItemGroup: !0,
		showForLineItem: !0
	};
	let n = jr(t);
	if (!e) return {
		showForLineItemGroup: n,
		showForLineItem: !n
	};
	if (!n) return {
		showForLineItemGroup: !1,
		showForLineItem: !0
	};
	let r = t[0].servicePeriod;
	return r ? {
		showForLineItemGroup: !(e.start === r.startDate && e.endInclusive === r.endDate),
		showForLineItem: !1
	} : {
		showForLineItemGroup: !1,
		showForLineItem: !1
	};
}, jr = (e) => {
	if (e.length === 0) return !0;
	let t = e[0]?.servicePeriod;
	return e.every((e) => {
		let n = e.servicePeriod;
		return t === void 0 && n === void 0 ? !0 : t === void 0 || n === void 0 ? !1 : t.startDate === n.startDate && t.endDate === n.endDate;
	});
}, Mr = (e, t) => e.index - t.index;
function Nr(e) {
	if (e) return O({
		from: new Date(e.startDate),
		to: new Date(e.endDate)
	});
}
function Pr({ lineItemGroups: e, currency: t, invoiceBillingPeriod: n, alwaysShowServicePeriod: r = !1 }) {
	if (!e || !t) return [];
	let i = r ? Fr(n) : void 0;
	return e.sort(Mr).map((e) => {
		let a = e.lineItems.at(0)?.servicePeriod, o = jr(e.lineItems), { showForLineItemGroup: s, showForLineItem: c } = r ? {
			showForLineItemGroup: o,
			showForLineItem: !o
		} : Ar({
			invoiceBillingPeriod: n,
			groupLineItems: e.lineItems
		});
		return {
			id: e.id,
			name: e.title,
			description: e.description,
			servicePeriod: s ? Nr(a) ?? i : void 0,
			lineItems: e.lineItems.sort(Mr).map((e) => ({
				id: e.id,
				name: e.title,
				description: e.description,
				qty: rr({
					quantity: e.quantity,
					rateDisplay: e.rateDisplay,
					currency: t
				}),
				rate: ir({
					rate: e.rate,
					rateDisplay: e.rateDisplay,
					currency: t
				}),
				tax: ar({ taxRate: e.taxRate }),
				amount: or({
					netTotal: e.netTotal,
					currency: t
				}),
				servicePeriod: c ? Nr(e.servicePeriod) ?? i : void 0
			}))
		};
	});
}
function Fr(e) {
	if (e) return O({
		from: new Date(e.start),
		to: new Date(e.endInclusive)
	});
}
//#endregion
//#region src/utils/getInvoiceTitle/getInvoiceTitle.ts
var Ir = ({ customerCountry: e, customerTaxStatus: t }) => {
	if (e === "SG" && t === "TAXED") return "Tax invoice";
};
//#endregion
//#region src/utils/resolveServicePeriods.ts
function Lr({ lineItemGroups: e, billingPeriod: t, alwaysShow: n }) {
	let r = n ? Br(t) : void 0;
	return e.map((e) => {
		let i = e.lineItems.map((e) => ({ servicePeriod: e.servicePeriodStart && e.servicePeriodEnd ? {
			startDate: Rr(e.servicePeriodStart),
			endDate: Rr(e.servicePeriodEnd)
		} : void 0 })), a = jr(i), { showForLineItemGroup: o, showForLineItem: s } = n ? {
			showForLineItemGroup: a,
			showForLineItem: !a
		} : Ar({
			invoiceBillingPeriod: t,
			groupLineItems: i
		}), c = i.at(0)?.servicePeriod, l = o ? zr(c) ?? r : void 0, { lineItems: u, ...ee } = e;
		return {
			...ee,
			servicePeriod: l,
			lineItems: e.lineItems.map((e, t) => {
				let { servicePeriodStart: n, servicePeriodEnd: a, ...o } = e;
				return {
					...o,
					servicePeriod: s ? zr(i[t].servicePeriod) ?? r : void 0
				};
			})
		};
	});
}
function Rr(e) {
	return ze(Be(e));
}
function zr(e) {
	if (e) return O({
		from: new Date(e.startDate),
		to: new Date(e.endDate)
	});
}
function Br(e) {
	if (e) return O({
		from: new Date(e.start),
		to: new Date(e.endInclusive)
	});
}
//#endregion
//#region src/utils/settlement/settlement.ts
var Vr = "Credit note", Hr = 2, Ur = "Credit applied", Wr = (e) => e ? `${Ur} - ${e}` : Ur, Gr = ({ appliedAmount: e, grossTotal: t }) => e ?? t, Kr = (e = []) => ni(e.map(Gr)), qr = (e) => e.status === "APPLIED", Jr = (e) => {
	try {
		return new j(e ?? "0").abs().toString();
	} catch {
		return "0";
	}
}, Yr = (e) => {
	try {
		return new j(e ?? "0");
	} catch {
		return new j(0);
	}
}, Xr = (e) => Jr(e.amount), Zr = (e) => Jr(e.taxAmount), Qr = (e) => new j(Xr(e)).plus(Zr(e)).toString(), $r = ({ appliedGrants: e, appliedCreditGrantTax: t }) => t == null ? ni(e.map(Zr)) : Jr(t), ei = ({ appliedCreditGrants: e, appliedCreditGrantTax: t }) => {
	let n = e.filter(qr);
	return new j(ni(n.map(Xr))).plus($r({
		appliedGrants: n,
		appliedCreditGrantTax: t
	})).toString();
}, ti = ({ grossTotal: e, creditApplied: t, creditProjected: n = "0" }) => {
	let r = Yr(e), i = Yr(t).round(2).plus(Yr(n).round(2));
	if (i.eq(0)) return r.toFixed(2);
	let a = r.minus(i);
	return (a.lt(0) ? new j(0) : a).toFixed(2);
}, ni = (e) => e.reduce((e, t) => e.plus(t), new j(0)).toString(), ri = ({ appliedCreditNotes: e, appliedCreditGrants: t, appliedCreditGrantTax: n }) => {
	let r = t.filter(qr), i = ni(r.map(Xr)), a = $r({
		appliedGrants: r,
		appliedCreditGrantTax: n
	});
	return {
		net: i,
		tax: a,
		gross: ni([
			i,
			a,
			Kr(e)
		])
	};
}, ii = (...e) => {
	let t = e.filter(Boolean);
	return t.length > 0 ? t.join("\n") : void 0;
}, ai = ({ lineItemGroups: e, currency: t }) => e.sort((e, t) => e.index - t.index).flatMap((e) => [{
	name: {
		text: e.title,
		caption: ii(e.description, e.servicePeriod)
	},
	indentation: 0
}, ...e.lineItems.sort((e, t) => e.index - t.index).flatMap((e) => ({
	name: {
		text: e.title,
		caption: ii(e.description, e.servicePeriod)
	},
	quantity: { text: rr({
		quantity: e.quantity,
		rateDisplay: e.rateDisplay,
		currency: t
	}) },
	rate: { text: ir({
		rate: e.rate,
		rateDisplay: e.rateDisplay,
		currency: t
	}) },
	tax: { text: ar({ taxRate: e.taxRate }) },
	amount: { text: or({
		netTotal: e.netTotal,
		currency: t
	}) },
	indentation: 1
}))]), oi = ({ netTotal: e, grossTotal: t, currency: n, lineItemGroups: r, hasDeductions: i }) => {
	let { taxRows: a } = sr({
		lineItemGroups: r,
		currency: n
	});
	return [
		{
			label: "Subtotal",
			value: y({
				value: e,
				currency: n
			})
		},
		...a.map(([e, t]) => ({
			label: e,
			value: y({
				value: t,
				currency: n
			})
		})),
		{
			label: "Total",
			value: y({
				value: t,
				currency: n,
				appendCurrencyCode: !i
			}),
			variant: i ? "total" : "grandTotal"
		}
	];
}, si = ({ appliedCreditNotes: e, appliedCreditGrants: t, appliedCreditGrantTax: n, amountDue: r, currency: i }) => {
	let a = t.filter(qr);
	if (!(e.length + a.length > 0)) return [];
	let o = (e) => y({
		value: new j(e).times(-1).toString(),
		currency: i
	}), s = e.map((e, t) => ({
		label: e.creditNoteNumber || "Credit note",
		value: o(Gr(e)),
		href: e.url,
		testId: e.id ? `invoice.settlement.creditNote.${e.id}-${t}` : void 0
	})), c = a.map((e) => ({
		label: Wr(e.creditGrantName),
		value: o(Xr(e)),
		testId: e.creditGrantId ? `invoice.settlement.creditGrant.${e.creditGrantId}` : void 0
	})), l = ri({
		appliedCreditNotes: e,
		appliedCreditGrants: a,
		appliedCreditGrantTax: n
	}), u = c.length > 0 ? [{
		label: "Adjustment subtotal",
		value: o(l.net),
		variant: "total",
		testId: "invoice.settlement.adjustmentSubtotal"
	}, {
		label: "Tax",
		value: o(l.tax)
	}] : [];
	return [
		...ci(c),
		...u,
		...ci(s),
		{
			label: "Adjustment total",
			value: o(l.gross),
			variant: "total"
		},
		{
			label: "Total due",
			value: y({
				value: r,
				currency: i,
				appendCurrencyCode: !0
			}),
			variant: "grandTotal"
		}
	];
}, ci = (e) => e.map((e, t) => t === 0 ? {
	...e,
	variant: "total"
} : e), Y = k(), li = k((e) => {
	let t = e(Y);
	return t ? y({
		value: t.grossTotal,
		currency: t.currency,
		appendCurrencyCode: !0
	}) : "$0.00";
}), ui = k((e) => {
	let t = e(Y);
	return t ? y({
		value: t.amountDue,
		currency: t.currency,
		appendCurrencyCode: !0
	}) : "$0.00";
}), di = k((e) => {
	let t = e(Y);
	return t ? si({
		appliedCreditNotes: t.appliedCreditNotes ?? [],
		appliedCreditGrants: t.appliedCreditGrants ?? [],
		appliedCreditGrantTax: t.appliedCreditGrantTax,
		amountDue: t.amountDue,
		currency: t.currency
	}) : [];
}), fi = k((e) => e(di).length > 0), pi = k((e) => e(fi) ? e(ui) : e(li)), mi = k((e) => {
	let t = e(Y)?.dueDate;
	return t ? Oe(t, nr) : void 0;
}), hi = k((e) => D(e(Y)?.dueDatePolicy).with({ type: "PAYMENT_TERMS" }, ({ paymentTermDays: e }) => `Net ${e}`).with({ type: "MANUAL" }, Re.nullish, () => void 0).exhaustive()), gi = k((e) => e(Y)?.urlPayOnline), _i = k((e) => e(Y)?.showAutoChargeMessage ?? !1), vi = k((e) => e(Y)?.usePdfInvoiceAlternativeHeader ?? !1), yi = k((e) => e(Y)?.merchantLegalCompanyName ?? ""), bi = k((e) => e(Y)?.merchantLogoUrl), xi = k((e) => e(Y)?.customerLegalCompanyName ?? ""), Si = k((e) => {
	let t = e(Y);
	return t ? [
		e(yi),
		t.merchantEmail,
		...t.merchantAddress,
		...t.merchantTaxId ? [`${q.TAX_ID_PREFIX} ${t.merchantTaxId}`] : []
	] : [];
}), Ci = k((e) => {
	let t = e(Y);
	return t ? [
		e(xi),
		...t.customerAddress,
		...t.customerTaxId ? [`${q.TAX_ID_PREFIX} ${t.customerTaxId}`] : []
	].filter(Boolean) : [];
}), wi = k((e) => e(Y)?.invoiceNumber), Ti = k((e) => e(Y)?.memo), Ei = k((e) => {
	let t = e(Y);
	return t ? ai({
		lineItemGroups: t.lineItemGroups,
		currency: t.currency
	}) : [];
}), Di = k((e) => {
	let t = e(Y);
	return t ? oi({
		netTotal: t.netTotal,
		grossTotal: t.grossTotal,
		currency: t.currency,
		lineItemGroups: t.lineItemGroups,
		hasDeductions: e(fi)
	}) : [];
}), Oi = k((e) => e(Y)?.status ?? "SENT"), ki = k((e) => e(Y)?.customerTaxStatus === "REVERSE_CHARGED"), Ai = k((e) => {
	let t = e(Y)?.issueDate;
	return t ? Oe(t, nr) : void 0;
}), ji = k((e) => {
	let t = e(Y)?.accountingDate;
	return t ? Oe(t, nr) : void 0;
}), Mi = k((e) => {
	let t = e(Y)?.billingPeriod;
	if (t) return O({
		from: new Date(t.start),
		to: new Date(t.endInclusive)
	});
}), Ni = k((e) => e(Y)?.purchaseOrderNumber), Pi = k((e) => e(Y)?.reference), Fi = k((e) => e(Y)?.urlViewOnline), Ii = k((e) => {
	let t = e(Y)?.currency;
	if (t) return `${t} - ${je(t)}`;
}), Li = k((e) => [
	{
		label: "Invoice no.",
		value: e(wi),
		href: e(Fi),
		width: "40%"
	},
	{
		label: "Invoice date",
		value: e(ji)
	},
	{
		label: "Issue date",
		value: e(Ai)
	},
	{
		label: "Due date",
		value: e(mi),
		"data-testid": "invoice.summary.dueDate"
	},
	{
		label: "Billing period",
		value: e(Mi)
	},
	{
		label: "Payment terms",
		value: e(hi),
		showSkeleton: !1,
		"data-testid": "invoice.summary.paymentTerms"
	},
	{
		label: "Currency",
		value: e(Ii)
	},
	{
		label: "PO number",
		value: e(Ni)
	},
	{
		label: "Reference",
		value: e(Pi)
	}
]), Ri = k((e) => {
	let t = e(Y);
	return t ? t.currencyConversions.map((e) => ({
		id: e.id,
		currency: e.currency,
		exchangeRateFrom: y({
			currency: t.currency,
			value: "1"
		}),
		exchangeRateTo: y({
			currency: e.currency,
			value: e.exchangeRate,
			maximumFractionDigits: 10
		}),
		subTotal: y({
			currency: e.currency,
			value: e.netTotal
		}),
		tax: y({
			currency: e.currency,
			value: e.totalTax
		}),
		total: y({
			currency: e.currency,
			value: e.grossTotal
		})
	})) : [];
}), zi = k((e) => {
	let t = e(Y);
	return t ? t.creditBalances.map((e) => ({
		id: e.id,
		name: e.name,
		totalBalance: D(e.type).with("CASH", () => y({
			currency: e.name,
			value: e.balance
		})).with("USAGE", () => `${e.balance} credits`).exhaustive(),
		grants: e.grants.map((e) => ({
			id: e.id,
			name: e.name,
			balance: D(e.type).with("CASH", () => `${y({
				currency: e.currency,
				value: e.currentBalance
			})}/${y({
				currency: e.currency,
				value: e.originalAmount
			})}`).with("USAGE", () => `${e.currentBalance}/${e.originalAmount} credits`).exhaustive(),
			expiresOn: e.expiryDate ? Oe(e.expiryDate, nr) : void 0
		}))
	})) : [];
}), Bi = k((e) => e(Y)?.subAccountUsage ?? []), Vi = k((e) => e(Y)?.paymentDetails ?? []), Hi = k((e) => e(Y)?.seatBreakdown ?? []), Ui = k((e) => e(Y)?.currency), Wi = k((e) => e(Y)?.invoiceTitle), Gi = k(!1), Ki = ({ row: e, value: t, isHeader: n, theme: r }) => ({
	textStyle: We(() => {
		if (n) return r.lineItemTable.header.cellText;
		let i = e[t];
		if (!i) return {};
		let { variant: a = "default" } = i;
		return {
			...r.lineItemTable.body.cellTextBase,
			...a === "secondary" ? r.lineItemTable.body.cellTextSecondary : {},
			...t === "name" && e.indentation === 0 ? r.lineItemTable.body.cellTextNameFirstLevel : {},
			...t === "name" && e.indentation !== 0 ? r.lineItemTable.body.cellTextNameSecondLevel : {}
		};
	}, [
		n,
		e,
		r,
		t
	]),
	captionStyle: r.lineItemTable.body.cellTextCaption
}), qi = ({ variant: e, theme: t }) => ({
	styleRow: We(() => D(e).with("default", () => t.totals.default.row).with("total", () => t.totals.total.row).with("grandTotal", () => t.totals.grandTotal.row).exhaustive(), [
		e,
		t.totals.default.row,
		t.totals.total.row,
		t.totals.grandTotal.row
	]),
	styleText: We(() => D(e).with("default", () => t.totals.default.text).with("total", () => t.totals.total.text).with("grandTotal", () => t.totals.grandTotal.text).exhaustive(), [
		e,
		t.totals.default.text,
		t.totals.total.text,
		t.totals.grandTotal.text
	])
}), Ji = k(!0), Yi = k({}), Xi = k(), Zi = () => {
	let e = A(pi), t = A(mi), n = A(gi), r = A(bi), i = A(yi), a = A(Wi), s = A(vi), c = A(G);
	return /* @__PURE__ */ S(o, {
		width: "100%",
		justifyContent: "space-between",
		...c.header.container,
		children: [/* @__PURE__ */ S(o, {
			flexDirection: "column",
			...c.header.total.container,
			flexShrink: "0",
			children: [
				a && /* @__PURE__ */ x(g, {
					...c.header.invoiceTitle,
					children: a
				}),
				/* @__PURE__ */ x(g, {
					"data-testid": "invoice.header.total",
					...s ? c.header.total.alternativeText : c.header.total.text,
					children: e
				}),
				(t || n) && /* @__PURE__ */ S(o, {
					...c.header.dueDatePayOnline.container,
					children: [t && /* @__PURE__ */ S(g, {
						"data-testid": "invoice.header.dueDate",
						...c.header.dueDatePayOnline.dueDateText,
						children: ["Due ", t]
					}), n && /* @__PURE__ */ x(g, {
						...c.header.dueDatePayOnline.urlPayOnlineText,
						children: "Pay online"
					})]
				})
			]
		}), r ? /* @__PURE__ */ x(ae, {
			src: r,
			...c.header.logo
		}) : /* @__PURE__ */ x(g, {
			...c.header.merchantName,
			children: i
		})]
	});
}, Qi = () => {
	let e = A(G);
	return /* @__PURE__ */ S(o, {
		gap: "4px",
		marginBottom: e.page.padding,
		children: [/* @__PURE__ */ x(g, {
			...e.poweredBy.text,
			children: "Powered by"
		}), /* @__PURE__ */ x(t, {
			transform: "translateY(1.5px)",
			children: /* @__PURE__ */ x(we, { ...e.poweredBy.logo })
		})]
	});
}, $i = () => {
	let e = Ge(null), n = Ye(Xi), r = A(wi), i = A(pi), a = A(mi), s = A(G);
	return Ue(() => {
		if (!e.current) return;
		let { height: t } = e.current.getBoundingClientRect();
		n(t);
	}, [n]), /* @__PURE__ */ S(t, {
		ref: e,
		position: "absolute",
		bottom: "0",
		left: "0",
		background: ne,
		padding: s.page.padding,
		width: "100%",
		children: [/* @__PURE__ */ x(Qi, {}), /* @__PURE__ */ x(o, {
			...s.footer.container,
			children: /* @__PURE__ */ S(g, {
				"data-testid": "invoice.footer.summary",
				...s.footer.summary,
				children: [
					r && `${r} - `,
					/* @__PURE__ */ x(g, {
						as: "span",
						...s.footer.total,
						children: i
					}),
					" ",
					a && `due ${a}`
				]
			})
		})]
	});
}, ea = Ve(({ children: e }, t) => {
	let n = A(G);
	return /* @__PURE__ */ x(re, {
		ref: t,
		width: "100%",
		templateColumns: `repeat(${n.gridSystem.columns}, 1fr)`,
		columnGap: n.gridSystem.columnGap,
		children: e
	});
}), ta = ({ width: e }) => /* @__PURE__ */ x(t, {
	width: e,
	height: "8px",
	borderRadius: "8px",
	background: l
}), na = [
	"80%",
	"65%",
	"70%",
	"75%"
], ra = ({ value: e, skeletonLines: t = 1, renderValue: n, children: r, width: i, "data-testid": a }) => {
	let s = A(Ji), c = Array.isArray(e) ? e.length > 0 : !!e;
	return !c && !s ? null : r(c ? n : /* @__PURE__ */ x(o, {
		flexDir: "column",
		gap: "4px",
		marginTop: "2px",
		"data-testid": a,
		children: Array.from({ length: t }).map((e, t) => /* @__PURE__ */ x(ta, { width: i ?? na[t % na.length] }, t))
	}));
}, ia = () => {
	let e = A(G), t = A(Ti), n = A(ki), r = A(Li);
	return /* @__PURE__ */ S(ea, { children: [/* @__PURE__ */ S(p, {
		colSpan: 7,
		children: [/* @__PURE__ */ x(g, {
			...e.summary.header,
			children: "Terms"
		}), /* @__PURE__ */ S(o, {
			flexDir: "column",
			...e.summary.containerTerms,
			children: [r.map((e) => /* @__PURE__ */ x(aa, { ...e }, e.label)), n && /* @__PURE__ */ x(g, {
				style: e.summary.value,
				children: q.REVERSE_CHARGED
			})]
		})]
	}), /* @__PURE__ */ x(ra, {
		value: t,
		renderValue: /* @__PURE__ */ x(g, {
			...e.summary.value,
			whiteSpace: "pre-line",
			children: t
		}),
		skeletonLines: 4,
		children: (t) => /* @__PURE__ */ S(p, {
			colSpan: 9,
			children: [/* @__PURE__ */ x(g, {
				...e.summary.header,
				children: "Memo"
			}), t]
		})
	})] });
}, aa = ({ label: e, value: t, href: n, width: r, showSkeleton: i = !0, "data-testid": a }) => {
	let o = A(G), s = n ? o.summary.valueLink : o.summary.value;
	return !t && !i ? null : /* @__PURE__ */ x(ra, {
		value: t,
		renderValue: /* @__PURE__ */ x(g, {
			...o.summary.value,
			...s,
			"data-testid": a,
			children: t
		}),
		skeletonLines: 1,
		width: r,
		"data-testid": a && `${a}.skeleton`,
		children: (t) => /* @__PURE__ */ S(re, {
			templateColumns: `${o.summary.label.container.width} 1fr`,
			children: [/* @__PURE__ */ x(p, { children: /* @__PURE__ */ x(g, {
				...o.summary.label.text,
				children: e
			}) }), /* @__PURE__ */ x(p, {
				alignContent: "center",
				wordBreak: "break-word",
				children: t
			})]
		})
	});
}, oa = ({ title: e, colSpan: t, lines: n }) => {
	let r = A(G);
	return /* @__PURE__ */ x(ra, {
		value: n,
		skeletonLines: 5,
		renderValue: n.map((e, t) => /* @__PURE__ */ x(g, {
			...r.contactDetails.body,
			children: e
		}, t)),
		children: (n) => /* @__PURE__ */ S(p, {
			colSpan: t,
			children: [/* @__PURE__ */ x(g, {
				...r.contactDetails.title,
				children: e
			}), n]
		})
	});
}, sa = () => {
	let e = A(Si), t = A(Ci);
	return /* @__PURE__ */ S(ea, { children: [/* @__PURE__ */ x(oa, {
		title: "From",
		colSpan: 7,
		lines: e
	}), /* @__PURE__ */ x(oa, {
		title: "To",
		colSpan: 9,
		lines: t
	})] });
}, ca = () => {
	let e = A(Di), t = A(ki), n = A(_i), r = A(G);
	return /* @__PURE__ */ x(ea, { children: /* @__PURE__ */ S(p, {
		colSpan: 9,
		colStart: 8,
		children: [/* @__PURE__ */ x(o, {
			flexDir: "column",
			...r.totals.container,
			children: e.map((e, t) => /* @__PURE__ */ x(la, { row: e }, t))
		}), (t || n) && /* @__PURE__ */ S(o, {
			flexDir: "column",
			...r.totalsCaptions.container,
			children: [t && /* @__PURE__ */ x(g, {
				...r.totalsCaptions.text,
				children: q.REVERSE_CHARGED
			}), n && /* @__PURE__ */ x(g, {
				...r.totalsCaptions.text,
				children: q.AUTO_CHARGED
			})]
		})]
	}) });
}, la = ({ row: e }) => {
	let { label: t, value: n, variant: r = "default" } = e, { styleRow: i, styleText: a } = qi({
		variant: r,
		theme: A(G)
	});
	return /* @__PURE__ */ S(o, {
		...i,
		justifyContent: "space-between",
		width: "100%",
		children: [/* @__PURE__ */ x(g, {
			...a,
			children: t
		}), /* @__PURE__ */ x(g, {
			...a,
			children: n
		})]
	});
}, ua = () => {
	let e = A(Di), t = A(di), n = A(ki), r = A(_i), i = A(G);
	return /* @__PURE__ */ x(ea, { children: /* @__PURE__ */ S(p, {
		colSpan: 9,
		colStart: 8,
		"data-testid": "invoice.settlement",
		children: [/* @__PURE__ */ x(o, {
			flexDir: "column",
			children: [...e, ...t].map((e, t) => /* @__PURE__ */ x(da, { row: e }, t))
		}), (n || r) && /* @__PURE__ */ S(o, {
			flexDir: "column",
			...i.totalsCaptions.container,
			children: [n && /* @__PURE__ */ x(g, {
				...i.totalsCaptions.text,
				children: q.REVERSE_CHARGED
			}), r && /* @__PURE__ */ x(g, {
				...i.totalsCaptions.text,
				children: q.AUTO_CHARGED
			})]
		})]
	}) });
}, da = ({ row: e }) => {
	let { label: t, value: n, variant: r = "default", href: i, testId: a } = e, s = A(G), { styleRow: c, styleText: l } = qi({
		variant: r,
		theme: s
	}), u = i ? s.totals.labelLink : l;
	return /* @__PURE__ */ S(o, {
		...c,
		paddingTop: "4px",
		paddingBottom: "4px",
		justifyContent: "space-between",
		width: "100%",
		"data-testid": a,
		children: [/* @__PURE__ */ x(g, {
			...u,
			...i ? {
				as: "a",
				href: i
			} : {},
			flex: 1,
			paddingRight: "8px",
			children: t
		}), /* @__PURE__ */ x(g, {
			...l,
			flexShrink: 0,
			textAlign: "right",
			children: n
		})]
	});
}, fa = ({ row: e, value: t, isHeader: n }) => {
	let r = A(G), { textStyle: i, captionStyle: a } = Ki({
		row: e,
		value: t,
		isHeader: n,
		theme: r
	}), s = e[t];
	return s?.variant === "skeleton" ? /* @__PURE__ */ x(o, {
		height: "15px",
		alignItems: "center",
		children: /* @__PURE__ */ x(ta, { width: "100%" })
	}) : /* @__PURE__ */ S(o, {
		flexDir: "column",
		...r.lineItemTable.body.cellContainer,
		children: [/* @__PURE__ */ x(g, {
			...i,
			children: s?.text
		}), s?.caption && t === "name" && /* @__PURE__ */ x(g, {
			...a,
			whiteSpace: "pre-line",
			children: s.caption
		})]
	});
}, pa = ({ row: e, isHeader: t = !1 }) => {
	let n = A(G), r = `${e.indentation * 8}px`, i = t ? n.lineItemTable.header.row : n.lineItemTable.body.row, a = {
		row: e,
		isHeader: t
	};
	return /* @__PURE__ */ S(re, {
		width: "100%",
		templateColumns: "repeat(16, 1fr)",
		columnGap: "16px",
		...i,
		children: [
			/* @__PURE__ */ x(p, {
				gridColumn: "span 7",
				paddingLeft: r,
				children: /* @__PURE__ */ x(fa, {
					...a,
					value: "name"
				})
			}),
			/* @__PURE__ */ x(p, {
				gridColumn: "span 2",
				children: /* @__PURE__ */ x(fa, {
					...a,
					value: "quantity"
				})
			}),
			/* @__PURE__ */ x(p, {
				gridColumn: "span 2",
				textAlign: "right",
				children: /* @__PURE__ */ x(fa, {
					...a,
					value: "rate"
				})
			}),
			/* @__PURE__ */ x(p, {
				gridColumn: "span 2",
				textAlign: "right",
				children: /* @__PURE__ */ x(fa, {
					...a,
					value: "tax"
				})
			}),
			/* @__PURE__ */ x(p, {
				gridColumn: "span 3",
				textAlign: "right",
				children: /* @__PURE__ */ x(fa, {
					...a,
					value: "amount"
				})
			})
		]
	});
}, ma = () => /* @__PURE__ */ x(pa, {
	isHeader: !0,
	row: {
		name: { text: "Name" },
		quantity: { text: "Qty" },
		rate: { text: "Rate" },
		tax: { text: "Tax" },
		amount: { text: "Amount" },
		indentation: 0
	}
}), ha = () => /* @__PURE__ */ x(pa, { row: {
	name: {
		text: "Name",
		variant: "skeleton"
	},
	quantity: {
		text: "Qty",
		variant: "skeleton"
	},
	rate: {
		text: "Rate",
		variant: "skeleton"
	},
	tax: {
		text: "Tax",
		variant: "skeleton"
	},
	amount: {
		text: "Price",
		variant: "skeleton"
	},
	indentation: 0
} }), ga = () => {
	let e = A(Ei), t = A(Ji);
	return /* @__PURE__ */ S(o, {
		flexDir: "column",
		width: "100%",
		children: [/* @__PURE__ */ x(ma, {}), e.length === 0 && t ? /* @__PURE__ */ x(ha, {}) : e.map((e, t) => /* @__PURE__ */ x(pa, { row: e }, t))]
	});
}, _a = () => A(Oi) === "VOIDED" ? /* @__PURE__ */ x(va, { text: "VOID" }) : null, va = ({ text: e }) => /* @__PURE__ */ x(r, {
	width: "100%",
	height: 960,
	zIndex: "1",
	position: "absolute",
	top: "0",
	left: "0",
	children: /* @__PURE__ */ x(g, {
		...A(G).watermark.text,
		children: e
	})
}), ya = ({ scale: e }) => {
	let n = Ge(null), r = Ye(Yi), i = A(G), a = A(Xi), s = A(Y), c = A(fi);
	return Ue(() => {
		if (!n.current) return;
		let e = n.current.getBoundingClientRect();
		r({
			width: e.width,
			height: e.height
		});
	}, [
		r,
		a,
		s,
		e
	]), /* @__PURE__ */ S(t, {
		ref: n,
		width: "680px",
		minHeight: "960px",
		background: ne,
		position: "relative",
		transform: `scale(${e})`,
		transformOrigin: "top left",
		...i.page,
		children: [
			/* @__PURE__ */ S(o, {
				flexDirection: "column",
				alignItems: "flex-start",
				...i.mainPage,
				paddingBottom: `${a}px`,
				children: [
					/* @__PURE__ */ x(Zi, {}),
					/* @__PURE__ */ x(sa, {}),
					/* @__PURE__ */ x(ia, {}),
					/* @__PURE__ */ S(o, {
						flexDir: "column",
						width: "100%",
						...i.lineItems.container,
						children: [/* @__PURE__ */ x(ga, {}), x(c ? ua : ca, {})]
					})
				]
			}),
			/* @__PURE__ */ x($i, {}),
			/* @__PURE__ */ x(_a, {})
		]
	});
}, ba = (e) => {
	let [n, i] = Je(Y), [a, o] = Je($n), [s, c] = Je(Ji), l = A(Yi);
	He(() => {
		e.data && !Xe(e.data, n) && i(e.data);
	}, [
		n,
		e.data,
		i
	]), He(() => {
		e.theme !== a && o(e.theme);
	}, [
		a,
		e.theme,
		o
	]), He(() => {
		e.showSkeletons !== s && c(e.showSkeletons);
	}, [
		s,
		e.showSkeletons,
		c
	]);
	let u = e.width / 680;
	return n ? /* @__PURE__ */ x(t, {
		width: l.width,
		height: l.height,
		overflow: "hidden",
		userSelect: "none",
		"data-testid": e["data-testid"],
		children: /* @__PURE__ */ x(ya, { scale: u })
	}) : /* @__PURE__ */ x(r, {
		width: 680 * u,
		height: 960 * u,
		children: /* @__PURE__ */ x(ve, {})
	});
}, xa = (e) => /* @__PURE__ */ x(qe, { children: /* @__PURE__ */ x(ba, { ...e }) }), Sa = () => {
	let e = A(K), t = A(wi), n = A(pi), r = A(mi);
	return /* @__PURE__ */ x(E, {
		fixed: !0,
		style: {
			position: "absolute",
			bottom: 0,
			left: e.page.padding,
			width: "100%",
			paddingTop: e.page.padding,
			paddingBottom: e.page.padding
		},
		children: /* @__PURE__ */ S(E, {
			style: {
				display: "flex",
				flexDirection: "row",
				justifyContent: "space-between",
				...e.footer.container
			},
			children: [/* @__PURE__ */ S(T, {
				style: e.footer.summary,
				children: [
					t && `${t} - `,
					/* @__PURE__ */ x(T, {
						style: e.footer.total,
						children: n
					}),
					" ",
					r && `due ${r}`
				]
			}), /* @__PURE__ */ x(T, {
				style: e.footer.summary,
				render: ({ pageNumber: e, totalPages: t }) => `Page ${e} of ${t}`
			})]
		})
	});
}, Ca = (e) => {
	let t = parseFloat(e.footer.container.paddingTop), n = parseFloat(e.footer.summary.fontSize), r = parseFloat(e.page.padding), i = parseFloat(e.footer.container.borderTopWidth);
	return `${r * 2 + i + n + t}px`;
}, wa = () => {
	let e = A(Oi), t = A(Gi);
	return /* @__PURE__ */ S(b, { children: [D(e).with("DRAFT", () => /* @__PURE__ */ x(Ta, { text: "DRAFT" })).with("VOIDED", () => /* @__PURE__ */ x(Ta, { text: "VOID" })).with("FINAL", "IN_PROGRESS", "SENT", () => null).exhaustive(), t && /* @__PURE__ */ x(Ta, { text: "TEST" })] });
}, Ta = ({ text: e }) => {
	let t = A(K);
	return /* @__PURE__ */ x(E, {
		fixed: !0,
		style: {
			width: "100%",
			height: "100%",
			position: "absolute",
			top: `${parseInt(t.page.padding, 10) * 2}px`,
			left: t.page.padding,
			display: "flex",
			justifyContent: "center",
			alignItems: "center"
		},
		children: /* @__PURE__ */ x(T, {
			style: t.watermark.text,
			children: e
		})
	});
}, X = ({ children: e }) => {
	let t = A(K), n = Ca(t);
	return /* @__PURE__ */ S(Fe, {
		size: "A4",
		dpi: 72,
		style: { padding: `${t.page.padding} ${t.page.padding} ${n}` },
		children: [
			e,
			/* @__PURE__ */ x(Sa, {}),
			/* @__PURE__ */ x(wa, {})
		]
	});
}, Z = Object.assign(({ children: e }) => /* @__PURE__ */ x(E, {
	style: {
		display: "flex",
		flexDirection: "column",
		...A(K).detailsBlock.container
	},
	children: e
}), {
	Header: Object.assign(({ children: e }) => /* @__PURE__ */ x(E, {
		style: {
			display: "flex",
			flexDirection: "column",
			...A(K).detailsBlock.header.container
		},
		children: e
	}), {
		Title: ({ children: e }) => /* @__PURE__ */ x(T, {
			style: A(K).detailsBlock.header.title,
			children: e
		}),
		Subtitle: ({ children: e }) => /* @__PURE__ */ x(T, {
			style: A(K).detailsBlock.header.subtitle,
			children: e
		})
	}),
	Group: ({ title: e, children: t, spacing: n = "default" }) => {
		let r = A(K);
		return /* @__PURE__ */ S(E, {
			style: {
				display: "flex",
				flexDirection: "column",
				...r.detailsBlock.group.container[n]
			},
			children: [e && /* @__PURE__ */ x(T, {
				style: r.detailsBlock.group.title,
				children: e
			}), t]
		});
	},
	Item: ({ title: e, titleColSpan: t = 3, children: n }) => {
		let r = A(K), i = r.gridSystem.columns - t;
		return /* @__PURE__ */ S(Q, {
			wrap: !1,
			children: [/* @__PURE__ */ x($, {
				colSpan: t,
				children: x(typeof e == "string" ? T : E, {
					style: r.detailsBlock.item.title,
					children: e
				})
			}), /* @__PURE__ */ x($, {
				colSpan: i,
				children: /* @__PURE__ */ x(E, {
					style: {
						display: "flex",
						flexDirection: "column",
						...r.detailsBlock.item.values.container,
						...r.detailsBlock.item.values.text
					},
					children: n
				})
			})]
		});
	}
}), Q = ({ children: e, style: t = {}, wrap: n = !0 }) => /* @__PURE__ */ x(E, {
	wrap: n,
	children: /* @__PURE__ */ x(E, {
		style: {
			...t,
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between"
		},
		children: e
	})
}), $ = ({ colSpan: e, colStart: t, children: n, style: r = {} }) => {
	let i = A(K), a = i.gridSystem.columns, o = parseInt(i.gridSystem.columnGap, 10), s = (595 - 2 * parseInt(i.page.padding, 10) - (a - 1) * o) / a, c = e * s + (e - 1) * o, l = t ? (t - 1) * s + (t - 1) * o : 0;
	return /* @__PURE__ */ x(E, {
		style: {
			...r,
			width: `${c}px`,
			marginLeft: `${l}px`
		},
		children: n
	});
}, Ea = (e) => {
	let t = typeof window < "u" ? {
		uri: e.src,
		method: "GET",
		headers: { "Cache-Control": "no-cache" },
		body: ""
	} : e.src;
	return /* @__PURE__ */ x(Pe, {
		...e,
		src: t
	});
}, Da = () => {
	let e = A(pi), t = A(mi), n = A(gi), r = A(bi), i = A(yi), a = A(Wi), o = A(vi), s = A(K);
	return /* @__PURE__ */ S(E, {
		style: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			...s.header.container
		},
		children: [/* @__PURE__ */ S(E, {
			style: s.header.total.container,
			children: [
				a && /* @__PURE__ */ x(T, {
					style: s.header.invoiceTitle,
					children: a
				}),
				/* @__PURE__ */ x(T, {
					style: o ? s.header.total.alternativeText : s.header.total.text,
					children: e
				}),
				(t || n) && /* @__PURE__ */ S(E, {
					style: {
						display: "flex",
						flexDirection: "row",
						...s.header.dueDatePayOnline.container
					},
					children: [t && /* @__PURE__ */ S(T, {
						style: s.header.dueDatePayOnline.dueDateText,
						children: ["Due ", t]
					}), n && /* @__PURE__ */ x(C, {
						src: n,
						style: s.header.dueDatePayOnline.urlPayOnlineText,
						children: "Pay online"
					})]
				})
			]
		}), r ? /* @__PURE__ */ x(Ea, {
			src: r,
			style: s.header.logo
		}) : /* @__PURE__ */ x(E, {
			style: { flex: 1 },
			children: /* @__PURE__ */ x(T, {
				style: s.header.merchantName,
				children: i
			})
		})]
	});
}, Oa = ({ title: e, colSpan: t, lines: n }) => {
	let r = A(K);
	return /* @__PURE__ */ S($, {
		colSpan: t,
		children: [/* @__PURE__ */ x(T, {
			style: r.contactDetails.title,
			children: e
		}), n.map((e, t) => /* @__PURE__ */ x(T, {
			style: r.contactDetails.body,
			children: e
		}, t))]
	});
}, ka = () => {
	let e = A(Si), t = A(Ci);
	return /* @__PURE__ */ S(Q, { children: [/* @__PURE__ */ x(Oa, {
		title: "From",
		colSpan: 7,
		lines: e
	}), /* @__PURE__ */ x(Oa, {
		title: "To",
		colSpan: 9,
		lines: t
	})] });
}, Aa = () => {
	let e = A(K), t = A(Ti), n = A(ki), r = A(Li);
	return /* @__PURE__ */ S(Q, { children: [/* @__PURE__ */ S($, {
		colSpan: 7,
		children: [/* @__PURE__ */ x(T, {
			style: e.summary.header,
			children: "Terms"
		}), /* @__PURE__ */ S(E, {
			style: e.summary.containerTerms,
			children: [r.map((e) => /* @__PURE__ */ x(ja, { ...e }, e.label)), n && /* @__PURE__ */ x(T, {
				style: e.summary.value,
				children: q.REVERSE_CHARGED
			})]
		})]
	}), t && /* @__PURE__ */ S($, {
		colSpan: 9,
		children: [/* @__PURE__ */ x(T, {
			style: e.summary.header,
			children: "Memo"
		}), /* @__PURE__ */ x(T, {
			style: e.summary.value,
			hyphenationCallback: (e) => [e],
			children: t
		})]
	})] });
}, ja = ({ label: e, value: t, href: n }) => {
	let r = A(K);
	return t ? /* @__PURE__ */ S(E, {
		style: {
			display: "flex",
			flexDirection: "row"
		},
		children: [/* @__PURE__ */ x(E, {
			style: r.summary.label.container,
			children: /* @__PURE__ */ x(T, {
				style: r.summary.label.text,
				children: e
			})
		}), /* @__PURE__ */ x(E, {
			style: { flex: 1 },
			children: n ? /* @__PURE__ */ x(C, {
				href: n,
				style: r.summary.valueLink,
				children: t
			}) : /* @__PURE__ */ x(T, {
				style: r.summary.value,
				children: t
			})
		})]
	}) : null;
}, Ma = ({ row: e, value: t, isHeader: n }) => {
	let r = A(K), { textStyle: i, captionStyle: a } = Ki({
		row: e,
		value: t,
		isHeader: n,
		theme: r
	}), o = e[t];
	return o?.variant === "skeleton" ? null : /* @__PURE__ */ S(E, {
		style: {
			display: "flex",
			flexDirection: "column",
			...r.lineItemTable.body.cellContainer
		},
		children: [/* @__PURE__ */ x(T, {
			style: i,
			children: o?.text
		}), o?.caption && t === "name" && /* @__PURE__ */ x(T, {
			style: a,
			children: o.caption
		})]
	});
}, Na = ({ row: e, isHeader: t = !1 }) => {
	let n = A(K), r = `${e.indentation * parseInt(n.lineItemTable.body.rowIndentation.paddingLeft, 10)}px`, i = t ? n.lineItemTable.header.row : n.lineItemTable.body.row, a = {
		row: e,
		isHeader: t
	};
	return /* @__PURE__ */ S(Q, {
		style: i,
		wrap: e.indentation === 0,
		children: [
			/* @__PURE__ */ x($, {
				colSpan: 7,
				style: { paddingLeft: r },
				children: /* @__PURE__ */ x(Ma, {
					...a,
					value: "name"
				})
			}),
			/* @__PURE__ */ x($, {
				colSpan: 2,
				children: /* @__PURE__ */ x(Ma, {
					...a,
					value: "quantity"
				})
			}),
			/* @__PURE__ */ x($, {
				colSpan: 2,
				style: { textAlign: "right" },
				children: /* @__PURE__ */ x(Ma, {
					...a,
					value: "rate"
				})
			}),
			/* @__PURE__ */ x($, {
				colSpan: 2,
				style: { textAlign: "right" },
				children: /* @__PURE__ */ x(Ma, {
					...a,
					value: "tax"
				})
			}),
			/* @__PURE__ */ x($, {
				colSpan: 3,
				style: { textAlign: "right" },
				children: /* @__PURE__ */ x(Ma, {
					...a,
					value: "amount"
				})
			})
		]
	});
}, Pa = () => /* @__PURE__ */ x(Na, {
	isHeader: !0,
	row: {
		name: { text: "Name" },
		quantity: { text: "Qty" },
		rate: { text: "Rate" },
		tax: { text: "Tax" },
		amount: { text: "Amount" },
		indentation: 0
	}
}), Fa = () => {
	let e = A(Ei);
	return /* @__PURE__ */ S(E, { children: [/* @__PURE__ */ x(Pa, {}), e.map((e, t) => /* @__PURE__ */ x(Na, { row: e }, t))] });
}, Ia = ({ rows: e }) => /* @__PURE__ */ x(E, {
	style: {
		display: "flex",
		flexDirection: "column",
		...A(K).totals.container
	},
	children: e.map((e, t) => /* @__PURE__ */ x(La, { row: e }, t))
}), La = ({ row: e }) => {
	let { label: t, value: n, variant: r = "default" } = e, { styleRow: i, styleText: a } = qi({
		variant: r,
		theme: A(K)
	});
	return /* @__PURE__ */ x(E, { children: /* @__PURE__ */ S(E, {
		style: {
			...i,
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			width: "100%"
		},
		children: [/* @__PURE__ */ x(T, {
			style: a,
			children: t
		}), /* @__PURE__ */ x(T, {
			style: a,
			children: n
		})]
	}) });
}, Ra = () => {
	let e = A(ki), t = A(_i), n = A(K);
	return !e && !t ? null : /* @__PURE__ */ S(E, {
		style: {
			display: "flex",
			flexDirection: "column",
			...n.totalsCaptions.container
		},
		children: [e && /* @__PURE__ */ x(T, {
			style: n.totalsCaptions.text,
			children: q.REVERSE_CHARGED
		}), t && /* @__PURE__ */ x(T, {
			style: n.totalsCaptions.text,
			children: q.AUTO_CHARGED
		})]
	});
}, za = () => /* @__PURE__ */ x(Q, {
	wrap: !1,
	children: /* @__PURE__ */ S($, {
		colSpan: 9,
		colStart: 8,
		children: [/* @__PURE__ */ x(Ia, { rows: A(Di) }), /* @__PURE__ */ x(Ra, {})]
	})
}), Ba = () => {
	let e = A(Di), t = A(di);
	return /* @__PURE__ */ x(Q, {
		wrap: !1,
		children: /* @__PURE__ */ S($, {
			colSpan: 9,
			colStart: 8,
			children: [/* @__PURE__ */ x(E, {
				style: {
					display: "flex",
					flexDirection: "column"
				},
				children: [...e, ...t].map((e, t) => /* @__PURE__ */ x(Va, { row: e }, t))
			}), /* @__PURE__ */ x(Ra, {})]
		})
	});
}, Va = ({ row: e }) => {
	let { label: t, value: n, variant: r = "default", href: i } = e, a = A(K), { styleRow: o, styleText: s } = qi({
		variant: r,
		theme: a
	}), c = {
		flex: 1,
		paddingRight: "8px"
	};
	return /* @__PURE__ */ S(E, {
		style: {
			...o,
			paddingTop: "4px",
			paddingBottom: "4px",
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			width: "100%"
		},
		children: [i ? /* @__PURE__ */ x(C, {
			href: i,
			style: {
				...a.totals.labelLink,
				...c
			},
			children: t
		}) : /* @__PURE__ */ x(T, {
			style: {
				...s,
				...c
			},
			children: t
		}), /* @__PURE__ */ x(T, {
			style: {
				...s,
				flexShrink: 0,
				textAlign: "right"
			},
			children: n
		})]
	});
}, Ha = ({ width: e, height: t }) => {
	let n = "#241F25";
	return /* @__PURE__ */ S(Le, {
		width: e,
		height: t,
		viewBox: "0 0 65 17",
		fill: "none",
		children: [
			/* @__PURE__ */ x(w, {
				d: "M5.36695 13.4171C6.63862 13.4171 7.64413 13.1422 8.36869 12.5923C9.09324 12.0423 9.46291 11.2898 9.46291 10.3347C9.46291 9.5388 9.19675 8.90206 8.66442 8.42451C8.1321 7.96143 7.27446 7.59964 6.07672 7.33916L5.15994 7.15103C4.27272 6.97738 3.68125 6.74584 3.35594 6.48535C3.03063 6.25381 2.86797 5.89203 2.86797 5.41447C2.86797 4.95139 3.04541 4.60408 3.41509 4.3436C3.76997 4.09758 4.3023 3.96734 4.99728 3.96734C5.88449 3.96734 6.52033 4.12653 6.91957 4.4449C7.31882 4.76327 7.54062 5.24082 7.59977 5.9065H9.16718C9.1376 4.89351 8.78272 4.09758 8.08774 3.51873C7.39275 2.93988 6.35767 2.65045 4.98249 2.65045C3.82912 2.65045 2.92712 2.91094 2.26171 3.41743C1.58151 3.92393 1.2562 4.60408 1.2562 5.44342C1.2562 6.29723 1.52237 6.96291 2.08427 7.44046C2.63138 7.93248 3.44466 8.2798 4.53889 8.48239L5.44089 8.67052C6.3281 8.87312 6.94915 9.09019 7.30403 9.3362C7.64413 9.58222 7.82157 9.92953 7.82157 10.3781C7.82157 10.9425 7.59977 11.3767 7.18574 11.6661C6.7717 11.9555 6.16544 12.1002 5.39653 12.1002C3.50381 12.1002 2.55745 11.3332 2.52787 9.78481H0.945679C0.945679 10.9715 1.34492 11.8832 2.11384 12.491C2.88276 13.1132 3.97699 13.4171 5.36695 13.4171Z",
				fill: n
			}),
			/* @__PURE__ */ x(w, {
				d: "M17.4454 9.50986C17.4454 8.35215 17.12 7.41152 16.4842 6.65901C15.8336 5.92097 14.9464 5.54472 13.8226 5.54472C12.7431 5.54472 11.8707 5.9065 11.2053 6.61559C10.5251 7.33916 10.1998 8.2798 10.1998 9.45197C10.1998 10.6386 10.5251 11.5793 11.2053 12.2884C11.8707 13.0119 12.7579 13.3592 13.8521 13.3592C14.7246 13.3592 15.4639 13.1422 16.0554 12.708C16.6469 12.2739 17.0609 11.6661 17.2679 10.8991H15.7744C15.4787 11.7384 14.8429 12.1436 13.8817 12.1436C13.2311 12.1436 12.7283 11.97 12.3587 11.5937C11.9742 11.2175 11.7524 10.6676 11.6933 9.92953H17.4454V9.50986ZM13.8226 6.76031C14.414 6.76031 14.8872 6.94843 15.2569 7.32469C15.6266 7.70094 15.8484 8.1785 15.9223 8.78629H11.7081C11.7968 8.13508 12.0186 7.62859 12.3882 7.28127C12.7579 6.93396 13.2311 6.76031 13.8226 6.76031Z",
				fill: n
			}),
			/* @__PURE__ */ x(w, {
				d: "M24.1134 6.81819C23.5367 5.97886 22.6938 5.54472 21.5848 5.54472C20.5202 5.54472 19.6625 5.9065 19.0415 6.60112C18.4057 7.31022 18.0951 8.26533 18.0951 9.45197C18.0951 10.6531 18.4057 11.6082 19.0415 12.3028C19.6625 13.0119 20.5202 13.3592 21.5848 13.3592C22.6495 13.3592 23.4775 12.9685 24.0542 12.1726V16.022H25.5329V5.71837H24.1134V6.81819ZM20.2392 11.4345C19.8252 10.9859 19.633 10.3492 19.633 9.50986C19.633 8.67052 19.8252 8.00484 20.2392 7.51282C20.6385 7.03526 21.1856 6.78925 21.8658 6.78925C22.5608 6.78925 23.1079 7.02079 23.5071 7.48387C23.8916 7.96143 24.0986 8.61264 24.0986 9.45197C24.0986 10.3058 23.8916 10.957 23.5071 11.4056C23.1079 11.8832 22.5608 12.1147 21.8658 12.1147C21.1856 12.1147 20.6385 11.8976 20.2392 11.4345Z",
				fill: n
			}),
			/* @__PURE__ */ x(w, {
				d: "M31.9068 9.92953C31.9068 10.6097 31.7146 11.1451 31.3449 11.5214C30.9753 11.8976 30.5169 12.0858 29.9845 12.0858C28.9051 12.0858 28.3728 11.5648 28.3728 10.5229V5.71837H26.8941V10.7254C26.8941 11.5648 27.1307 12.2015 27.6039 12.6646C28.077 13.1277 28.7277 13.3592 29.5705 13.3592C30.576 13.3592 31.3745 12.9396 31.966 12.0713V13.1856H33.3855V5.71837H31.9068V9.92953Z",
				fill: n
			}),
			/* @__PURE__ */ x(w, {
				d: "M41.6368 9.50986C41.6368 8.35215 41.3115 7.41152 40.6756 6.65901C40.025 5.92097 39.1378 5.54472 38.014 5.54472C36.9346 5.54472 36.0621 5.9065 35.3967 6.61559C34.7165 7.33916 34.3912 8.2798 34.3912 9.45197C34.3912 10.6386 34.7165 11.5793 35.3967 12.2884C36.0621 13.0119 36.9493 13.3592 38.0436 13.3592C38.916 13.3592 39.6553 13.1422 40.2468 12.708C40.8383 12.2739 41.2523 11.6661 41.4593 10.8991H39.9659C39.6701 11.7384 39.0343 12.1436 38.0731 12.1436C37.4225 12.1436 36.9198 11.97 36.5501 11.5937C36.1656 11.2175 35.9438 10.6676 35.8847 9.92953H41.6368V9.50986ZM38.014 6.76031C38.6055 6.76031 39.0786 6.94843 39.4483 7.32469C39.818 7.70094 40.0398 8.1785 40.1137 8.78629H35.8995C35.9882 8.13508 36.21 7.62859 36.5797 7.28127C36.9493 6.93396 37.4225 6.76031 38.014 6.76031Z",
				fill: n
			}),
			/* @__PURE__ */ x(w, {
				d: "M46.4564 5.54472C45.4362 5.54472 44.6377 5.97886 44.061 6.83266V5.71837H42.6414V13.1856H44.1201V8.97442C44.1201 8.2798 44.3124 7.74436 44.7116 7.3681C45.0961 7.00632 45.5397 6.81819 46.0424 6.81819C47.1071 6.81819 47.6542 7.33916 47.6542 8.3811V13.1856H49.1329V8.1785C49.1329 7.33916 48.8963 6.70242 48.4231 6.23934C47.9499 5.77626 47.2845 5.54472 46.4564 5.54472Z",
				fill: n
			}),
			/* @__PURE__ */ x(w, {
				d: "M53.7761 13.3592C54.6929 13.3592 55.4618 13.1132 56.0829 12.5923C56.7039 12.0858 57.0736 11.3911 57.1919 10.5229H55.6836C55.5949 11.0438 55.3731 11.4345 55.033 11.695C54.6781 11.97 54.2641 12.1002 53.7761 12.1002C53.1255 12.1002 52.6228 11.8832 52.2383 11.4201C51.8538 10.957 51.6764 10.3058 51.6764 9.45197C51.6764 8.61264 51.8538 7.96143 52.2383 7.49834C52.6228 7.03526 53.1255 6.80372 53.7761 6.80372C54.2493 6.80372 54.6633 6.93396 55.0034 7.19445C55.3435 7.45493 55.5653 7.83119 55.6689 8.32321H57.1771C57.0588 7.48387 56.6891 6.80372 56.0829 6.29723C55.4766 5.8052 54.7077 5.54472 53.7761 5.54472C52.6819 5.54472 51.7947 5.9065 51.1441 6.60112C50.4639 7.32469 50.1386 8.26533 50.1386 9.45197C50.1386 10.6386 50.4639 11.5793 51.1441 12.2884C51.8095 13.0119 52.6819 13.3592 53.7761 13.3592Z",
				fill: n
			}),
			/* @__PURE__ */ x(w, {
				d: "M64.9473 9.50986C64.9473 8.35215 64.622 7.41152 63.9862 6.65901C63.3356 5.92097 62.4484 5.54472 61.3246 5.54472C60.2451 5.54472 59.3727 5.9065 58.7073 6.61559C58.0271 7.33916 57.7018 8.2798 57.7018 9.45197C57.7018 10.6386 58.0271 11.5793 58.7073 12.2884C59.3727 13.0119 60.2599 13.3592 61.3541 13.3592C62.2266 13.3592 62.9659 13.1422 63.5574 12.708C64.1488 12.2739 64.5629 11.6661 64.7699 10.8991H63.2764C62.9807 11.7384 62.3449 12.1436 61.3837 12.1436C60.7331 12.1436 60.2303 11.97 59.8607 11.5937C59.4762 11.2175 59.2544 10.6676 59.1952 9.92953H64.9473V9.50986ZM61.3246 6.76031C61.916 6.76031 62.3892 6.94843 62.7589 7.32469C63.1286 7.70094 63.3504 8.1785 63.4243 8.78629H59.21C59.2988 8.13508 59.5206 7.62859 59.8902 7.28127C60.2599 6.93396 60.7331 6.76031 61.3246 6.76031Z",
				fill: n
			})
		]
	});
}, Ua = () => {
	let e = A(K);
	return /* @__PURE__ */ x(E, {
		style: {
			position: "absolute",
			bottom: Ca(e),
			left: e.page.padding
		},
		children: /* @__PURE__ */ S(C, {
			href: "https://sequencehq.com/?utm_campaign=pdf-invoice",
			style: {
				gap: "2px",
				display: "flex",
				flexDirection: "row",
				textDecoration: "none"
			},
			children: [/* @__PURE__ */ x(T, {
				style: e.poweredBy.text,
				children: "Powered by"
			}), /* @__PURE__ */ x(Ha, { ...e.poweredBy.logo })]
		})
	});
}, Wa = () => {
	let e = A(K), t = A(fi);
	return /* @__PURE__ */ S(X, { children: [/* @__PURE__ */ S(E, {
		style: e.mainPage,
		children: [
			/* @__PURE__ */ x(Da, {}),
			/* @__PURE__ */ x(ka, {}),
			/* @__PURE__ */ x(Aa, {}),
			/* @__PURE__ */ S(E, {
				style: e.lineItems.container,
				children: [/* @__PURE__ */ x(Fa, {}), x(t ? Ba : za, {})]
			})
		]
	}), /* @__PURE__ */ x(Ua, {})] });
}, Ga = () => {
	let t = A(K), n = A(Ri);
	return n.length ? /* @__PURE__ */ x(X, { children: /* @__PURE__ */ S(Z, { children: [/* @__PURE__ */ x(Z.Header, { children: /* @__PURE__ */ x(Z.Header.Title, { children: "Currency conversion" }) }), n.map((n) => /* @__PURE__ */ S(Z.Group, { children: [
		/* @__PURE__ */ x(Z.Item, {
			title: "Currency",
			children: /* @__PURE__ */ x(T, { children: n.currency })
		}),
		/* @__PURE__ */ x(Z.Item, {
			title: "Exchange rate",
			children: /* @__PURE__ */ S(E, {
				style: {
					flexDirection: "row",
					alignItems: "center",
					...t.currencyConversion.exchangeRate.container
				},
				children: [
					/* @__PURE__ */ x(T, { children: n.exchangeRateFrom }),
					/* @__PURE__ */ x(e, {
						style: {
							position: "relative",
							top: "-0.5px"
						},
						...t.currencyConversion.exchangeRate.icon
					}),
					/* @__PURE__ */ x(T, { children: n.exchangeRateTo })
				]
			})
		}),
		/* @__PURE__ */ x(Z.Item, {
			title: "Subtotal",
			children: /* @__PURE__ */ x(T, { children: n.subTotal })
		}),
		/* @__PURE__ */ x(Z.Item, {
			title: "Tax",
			children: /* @__PURE__ */ x(T, { children: n.tax })
		}),
		/* @__PURE__ */ x(Z.Item, {
			title: "Total",
			children: /* @__PURE__ */ x(T, { children: n.total })
		})
	] }, n.id))] }) }) : null;
}, Ka = () => {
	let e = A(zi);
	return e.length ? /* @__PURE__ */ x(X, { children: /* @__PURE__ */ S(Z, { children: [/* @__PURE__ */ x(Z.Header, { children: /* @__PURE__ */ x(Z.Header.Title, { children: "Credits" }) }), e.map((e) => /* @__PURE__ */ S(Z.Group, {
		title: e.name,
		spacing: "lg",
		children: [/* @__PURE__ */ x(Z.Item, {
			title: /* @__PURE__ */ x(T, {
				style: { fontWeight: 600 },
				children: "Total balance"
			}),
			children: /* @__PURE__ */ x(T, {
				style: { fontWeight: 600 },
				children: e.totalBalance
			})
		}), e.grants.map((e) => /* @__PURE__ */ S(Z.Group, { children: [
			/* @__PURE__ */ x(Z.Item, {
				title: "Name",
				children: /* @__PURE__ */ x(T, { children: e.name })
			}),
			/* @__PURE__ */ x(Z.Item, {
				title: "Balance",
				children: /* @__PURE__ */ x(T, { children: e.balance })
			}),
			e.expiresOn && /* @__PURE__ */ x(Z.Item, {
				title: "Expires on",
				children: /* @__PURE__ */ x(T, { children: e.expiresOn })
			})
		] }, e.id))]
	}, e.id))] }) }) : null;
}, qa = () => {
	let e = A(yi), t = A(Vi);
	return t.length ? /* @__PURE__ */ x(X, { children: /* @__PURE__ */ S(Z, { children: [/* @__PURE__ */ S(Z.Header, { children: [/* @__PURE__ */ x(Z.Header.Title, { children: "Payment details" }), /* @__PURE__ */ S(Z.Header.Subtitle, { children: ["Use the details below to pay ", e] })] }), t.map((e, t) => /* @__PURE__ */ x(Z.Group, {
		title: e.description,
		children: e.fields.map(({ label: e, lines: t }, n) => /* @__PURE__ */ x(Z.Item, {
			title: e,
			titleColSpan: 8,
			children: t.map((e, t) => /* @__PURE__ */ x(T, { children: e }, t))
		}, n))
	}, t))] }) }) : null;
}, Ja = () => {
	let e = A(Bi);
	return e.length ? /* @__PURE__ */ x(X, { children: /* @__PURE__ */ S(Z, { children: [/* @__PURE__ */ x(Z.Header, { children: /* @__PURE__ */ x(Z.Header.Title, { children: "Sub account usage" }) }), e.map((e, t) => /* @__PURE__ */ S(Z.Group, { children: [/* @__PURE__ */ x(Z.Item, {
		title: "Account name",
		titleColSpan: 8,
		children: /* @__PURE__ */ x(T, {
			style: { fontWeight: "bold" },
			children: e.subAccountLabel
		})
	}), e.usageData.map(({ label: e, quantity: t }, n) => /* @__PURE__ */ x(Z.Item, {
		title: e,
		titleColSpan: 8,
		children: /* @__PURE__ */ x(T, { children: t })
	}, n))] }, t))] }) }) : null;
}, Ya = () => {
	let e = A(Hi), t = A(Ui), n = A(K);
	if (!e || e.length === 0 || !t) return null;
	let r = e.reduce((e, t) => e + parseFloat(t.subtotal || "0"), 0).toString(), i = parseInt(n.lineItemTable.body.rowIndentation.paddingLeft, 10);
	return /* @__PURE__ */ x(X, { children: /* @__PURE__ */ S(E, {
		style: n.detailsBlock.container,
		children: [
			/* @__PURE__ */ x(T, {
				style: n.detailsBlock.header.title,
				children: "Seats breakdown"
			}),
			/* @__PURE__ */ S(Q, {
				style: n.lineItemTable.header.row,
				wrap: !1,
				children: [
					/* @__PURE__ */ x($, {
						colSpan: 6,
						children: /* @__PURE__ */ x(T, {
							style: n.lineItemTable.header.cellText,
							children: "Name"
						})
					}),
					/* @__PURE__ */ x($, {
						colSpan: 2,
						style: { textAlign: "right" },
						children: /* @__PURE__ */ x(T, {
							style: n.lineItemTable.header.cellText,
							children: "Days"
						})
					}),
					/* @__PURE__ */ x($, {
						colSpan: 2,
						style: { textAlign: "right" },
						children: /* @__PURE__ */ x(T, {
							style: n.lineItemTable.header.cellText,
							children: "Qty"
						})
					}),
					/* @__PURE__ */ x($, {
						colSpan: 3,
						style: { textAlign: "right" },
						children: /* @__PURE__ */ x(T, {
							style: n.lineItemTable.header.cellText,
							children: "Rate"
						})
					}),
					/* @__PURE__ */ x($, {
						colSpan: 3,
						style: { textAlign: "right" },
						children: /* @__PURE__ */ x(T, {
							style: n.lineItemTable.header.cellText,
							children: "Price"
						})
					})
				]
			}),
			e.map((e, r) => /* @__PURE__ */ S(E, { children: [
				/* @__PURE__ */ x(Q, {
					style: n.lineItemTable.body.row,
					wrap: !1,
					children: /* @__PURE__ */ x($, {
						colSpan: 16,
						children: /* @__PURE__ */ S(T, {
							style: n.lineItemTable.body.cellTextNameFirstLevel,
							children: [e.groupTitle, e.groupDescription && ` (${e.groupDescription})`]
						})
					})
				}),
				e.lineItems.map((e, r) => /* @__PURE__ */ S(Q, {
					style: n.lineItemTable.body.row,
					wrap: !1,
					children: [
						/* @__PURE__ */ x($, {
							colSpan: 6,
							style: { paddingLeft: `${i}px` },
							children: /* @__PURE__ */ x(T, {
								style: {
									...n.lineItemTable.body.cellTextBase,
									...n.lineItemTable.body.cellTextNameSecondLevel
								},
								children: e.title
							})
						}),
						/* @__PURE__ */ x($, {
							colSpan: 2,
							style: { textAlign: "right" },
							children: /* @__PURE__ */ x(T, {
								style: n.lineItemTable.body.cellTextBase,
								children: e.servicePeriod || "-"
							})
						}),
						/* @__PURE__ */ x($, {
							colSpan: 2,
							style: { textAlign: "right" },
							children: /* @__PURE__ */ x(T, {
								style: n.lineItemTable.body.cellTextBase,
								children: e.quantity
							})
						}),
						/* @__PURE__ */ x($, {
							colSpan: 3,
							style: { textAlign: "right" },
							children: /* @__PURE__ */ x(T, {
								style: n.lineItemTable.body.cellTextBase,
								children: y({
									value: e.rate,
									currency: t
								})
							})
						}),
						/* @__PURE__ */ x($, {
							colSpan: 3,
							style: { textAlign: "right" },
							children: /* @__PURE__ */ x(T, {
								style: n.lineItemTable.body.cellTextBase,
								children: y({
									value: e.netTotal,
									currency: t
								})
							})
						})
					]
				}, r)),
				/* @__PURE__ */ S(Q, {
					style: n.lineItemTable.body.row,
					wrap: !1,
					children: [/* @__PURE__ */ x($, {
						colSpan: 13,
						children: /* @__PURE__ */ x(T, {
							style: {
								...n.lineItemTable.body.cellTextBase,
								...n.lineItemTable.body.cellTextSecondary
							},
							children: "Subtotal"
						})
					}), /* @__PURE__ */ x($, {
						colSpan: 3,
						style: { textAlign: "right" },
						children: /* @__PURE__ */ x(T, {
							style: {
								...n.lineItemTable.body.cellTextBase,
								...n.lineItemTable.body.cellTextSecondary
							},
							children: y({
								value: e.subtotal,
								currency: t
							})
						})
					})]
				})
			] }, r)),
			/* @__PURE__ */ S(Q, {
				style: n.lineItemTable.body.row,
				wrap: !1,
				children: [/* @__PURE__ */ x($, {
					colSpan: 13,
					children: /* @__PURE__ */ x(T, {
						style: n.lineItemTable.body.cellTextNameFirstLevel,
						children: "Total"
					})
				}), /* @__PURE__ */ x($, {
					colSpan: 3,
					style: { textAlign: "right" },
					children: /* @__PURE__ */ x(T, {
						style: n.lineItemTable.body.cellTextNameFirstLevel,
						children: y({
							value: r,
							currency: t
						})
					})
				})]
			})
		]
	}) });
};
//#endregion
//#region src/renderers/PdfInvoiceRenderer/PdfInvoiceRenderer.tsx
Ae();
var Xa = ({ theme: e, data: t, isProductionEnv: n = !0 }) => (Ze([
	[$n, e],
	[Y, t],
	[Gi, !n]
]), /* @__PURE__ */ S(Ne, { children: [
	/* @__PURE__ */ x(Wa, {}),
	/* @__PURE__ */ x(qa, {}),
	/* @__PURE__ */ x(Ga, {}),
	/* @__PURE__ */ x(Ka, {}),
	/* @__PURE__ */ x(Ja, {}),
	/* @__PURE__ */ x(Ya, {})
] })), Za = (e) => /* @__PURE__ */ x(qe, { children: /* @__PURE__ */ x(Xa, { ...e }) });
//#endregion
export { Vr as CREDIT_NOTE_LABEL, tt as CanadianInternationalPaymentDetails, nt as CanadianPaymentDetails, Hr as DISPLAYED_DECIMAL_PLACES, En as GroupSummary, rt as IbanPaymentDetails, Kn as LineItemsTable, Un as PaymentDetailsModal, Za as PdfInvoiceRenderer, xa as ReactInvoiceRenderer, Cn as ReactPdfCreditNote, Hn as SubAccountUsageBreakdownCard, et as UkPaymentDetails, it as UsAchPaymentDetails, at as UsWirePaymentDetails, kr as flattenSubAccountUsage, or as formatAmount, Pr as formatLineItemGroups, Or as formatPaymentDetails, rr as formatQuantity, ir as formatRate, un as formatServicePeriodWithFallback, ar as formatTaxRate, Ir as getInvoiceTitle, Ln as getPaymentAccountDetails, qr as isGrantApplied, sr as lineItemGroupsToBreakdownRows, Lr as resolveServicePeriods, Kr as sumAppliedCreditNoteAmounts, Gr as toAppliedCreditNoteAmount, ei as toAppliedGrantCredit, Wr as toCreditAppliedLabel, Qr as toGrantGrossTotal, Xr as toGrantNetAmount, Zr as toGrantTaxAmount, ri as toSettlementTotals, ti as toTotalAfterCreditGrants };

//# sourceMappingURL=index.js.map